/* ============================================================================
   Merchloop store update wizard.

   For customers who already have a company store. Four steps:
     1 Your store   find the store in the store index, load its live products,
                    and how to reach you
     2 Changes      one change list, built from two places:
                      Add      products from the Merchloop catalog
                      Revise   a product already in the store, either
                               new artwork on it, or swap it for a catalog product
     3 Details      colors, print location and artwork for each change
     4 Review       check it over and send

   Sends to the same HubSpot form as the store request wizard, by the same
   off screen embed (the only browser path that carries a logo file), with the
   HubSpot Forms API and then email as fallbacks.

   Depends on assets/mlsr-catalog.js (window.MLSRCatalog) for the catalog
   picker and on assets/mlsr-wizard.css for the look. Never loads
   mlsr-wizard.js, and boots only on [data-mlsu-root].
   ========================================================================== */
(function () {
  'use strict';

  var DRAFT_KEY = 'mlsuDraft:v1';
  var MAX_LOGO_MB = 9;
  var MAX_LOGOS = 6;
  var MAX_CHANGES = 30;
  var MAX_COLORS = 7;
  var MAX_LOCS = 4;
  var ACCEPT_ATTR = '.png,.jpg,.jpeg,.gif,.svg,.webp,.pdf,.ai,.eps,image/*,application/pdf,application/postscript';
  var ACCEPT_EXT = /\.(png|jpe?g|gif|svg|webp|pdf|ai|eps)$/i;

  var TYPE_LABEL = { add: 'New product', artwork: 'New artwork', swap: 'Product swap' };
  /* Must match the option values of the store_request_type ticket property in
     HubSpot. A select on the form silently drops anything outside its list. */
  var HS_TYPE = { add: 'Add Products', artwork: 'Revise Artwork', swap: 'Swap Product', multi: 'Multiple Changes' };

  var I = {
    check: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    chevR: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>',
    chevL: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>',
    x: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    plus: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
    info: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>',
    up: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',
    clock: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
    chat: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>',
    cal: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>',
    search: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>',
    store: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l1.5-5h15L21 9"/><path d="M3 9h18v2a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0V9z"/><path d="M5 13v8h14v-8"/></svg>',
    bag: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>',
    edit: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>',
    brush: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="13.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="10.5" r="2.5"/><circle cx="8.5" cy="7.5" r="2.5"/><circle cx="6.5" cy="12.5" r="2.5"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.93 0 1.5-.75 1.5-1.5 0-.4-.15-.74-.4-1-.25-.27-.4-.62-.4-1 0-.83.67-1.5 1.5-1.5H16c3.31 0 6-2.69 6-6 0-4.96-4.49-9-10-9z"/></svg>',
    swap: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>',
    zoom: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>',
    arrow: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var v = (cents || 0) / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function scrollTop() {
    var root = document.querySelector('[data-mlsu-root]');
    var y = root ? root.getBoundingClientRect().top + window.pageYOffset - 90 : 0;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }
  function uid() { return 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
  function emailOk(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v || '').trim()); }
  function phoneOk(v) { return String(v || '').replace(/\D/g, '').length >= 7; }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function words(s) {
    return String(s || '').replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
  }

  function Wizard(root) {
    var cfg = JSON.parse(root.querySelector('[data-mlsu-config]').textContent);
    var elSteps = root.querySelector('[data-mlsu-steps]');
    var elTrack = root.querySelector('[data-mlsu-track]');

    var state = {
      started: false,
      step: 1,
      // Step 2 has views rather than more steps: the hub, the catalog, the
      // store's own products, and the catalog again choosing a swap.
      view: 'hub',
      data: {
        store: null,                 // { title, handle }
        firstName: '', lastName: '', email: '', phone: '',
        notes: '',
        changes: []
      },
      // { id, file, name, previewUrl }. Files cannot be drafted, so these
      // reset on a reload, and validation asks for anything that went missing.
      logos: [],
      products: null,                // the store's live products
      productsState: 'idle',         // idle loading ready error
      reviseQ: '',
      modal: null,                   // product id whose revise panel is open
      draft: null,                   // the revise panel's working copy
      errors: {},
      submitting: false,
      hsError: '',
      unattached: {},
      noFiles: false
    };
    var logoSeq = 0;

    function stepNames() { return ['Your store', 'Changes', 'Details', 'Review']; }

    /* -- changes -------------------------------------------------------------- */

    function changes(type) {
      return type ? state.data.changes.filter(function (c) { return c.type === type; }) : state.data.changes;
    }
    function changeFor(pid) {
      return state.data.changes.filter(function (c) { return c.type !== 'add' && String(c.pid) === String(pid); })[0] || null;
    }
    function storeProduct(pid) {
      return (state.products || []).filter(function (p) { return String(p.id) === String(pid); })[0] || null;
    }
    /* -- the catalog product behind a store product ----------------------------
       A store product is a copy of a catalog product, titled "<Store> - <catalog
       name> vN", with no metafield pointing back. So we find its catalog original
       by name, through the same scoped /search fragment the picker uses, and take
       that product's real decoration spots (merchloop.decoration_spots) instead
       of offering every print location we have for a cap. */
    var catMatch = {};      // pid -> { state: loading|ready|none, h, title, spots }

    function baseTitle(sp) {
      var t = String(sp.title || '');
      var store = state.data.store && state.data.store.title;
      if (store && t.toLowerCase().indexOf(store.toLowerCase() + ' - ') === 0) t = t.slice(store.length + 3);
      else if (t.indexOf(' - ') > -1) t = t.slice(t.indexOf(' - ') + 3);
      return t.replace(/\s+v\d+\s*$/i, '').trim();
    }
    // Catalog titles end in a style number ("... Trucker Cap 112R") and printed
    // twins carry a "PRINTED - " prefix; neither appears in the store's copy.
    function catKey(title) {
      var w = norm(String(title || '').replace(/^printed\s*-\s*/i, '')).split(' ');
      while (w.length > 1 && /\d/.test(w[w.length - 1])) w.pop();
      return w.join(' ');
    }
    function looksPrinted(sp) {
      return /print|dtf|uv|screen|sublim/i.test([sp.type].concat(sp.tags || []).join(' '));
    }
    function lookupCatalog(sp) {
      var pid = String(sp.id);
      if (catMatch[pid]) return;
      catMatch[pid] = { state: 'loading' };
      var base = baseTitle(sp), want = norm(base);
      if (!want) { catMatch[pid] = { state: 'none' }; return; }
      var wantWords = want.split(' '), printed = looksPrinted(sp);
      // A style number in the name (ST350, 1717, 112R) pins the product.
      var styleToks = wantWords.filter(function (w) { return /\d/.test(w) && w.length >= 3; });
      function pick(list) {
        var best = null, bestScore = 0, second = 0;
        list.forEach(function (p) {
          var key = catKey(p.title), score, kw = key.split(' ');
          var allW = norm(p.title).split(' ');
          var hit = wantWords.filter(function (w) { return kw.indexOf(w) > -1; }).length;
          if (key === want) score = 1;
          else if (styleToks.some(function (t) { return allW.indexOf(t) > -1; })) score = 0.97;
          // Every word of the store's name is in the catalog name.
          else if (hit === wantWords.length) score = 0.8 + 0.15 * (hit / kw.length);
          // Store names often lead with a design name ("Linear Richardson
          // Trucker Cap"), so a catalog name sitting wholly inside the store's
          // name counts as well.
          else if (kw.length >= 2 && hit === kw.length) score = 0.8 + 0.15 * (kw.length / wantWords.length);
          else score = hit / Math.max(wantWords.length, kw.length);
          // Same name, printed and embroidered twins: follow the store copy.
          if (/^printed\s*-/i.test(p.title) === printed) score += 0.01;
          if (score > bestScore) { second = bestScore; bestScore = score; best = p; }
          else if (score > second) second = score;
        });
        // A loose match with a close runner up is a guess between two different
        // products, so fall back to the category's locations.
        if (bestScore < 0.97 && second >= bestScore - 0.05) return null;
        return best && bestScore >= 0.75 ? best : null;
      }
      function fetchList(q) {
        var full = q + ' tag:"' + (cfg.catalog_tag || 'Catalog Products') + '"';
        return fetch('/search?type=product&q=' + encodeURIComponent(full) + '&view=mlsrpick', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var tag = doc.querySelector('[data-mlsr-catdata]');
            return tag ? (JSON.parse(tag.textContent).products || []) : [];
          });
      }
      // The design name in front rarely appears in the catalog, so a search
      // for the whole title can come back empty. Retry with leading words
      // dropped, one at a time.
      var bw = base.split(/\s+/).filter(Boolean), queries = [];
      for (var qi = 0; qi < Math.max(1, bw.length - 1) && qi < 3; qi++) queries.push(bw.slice(qi).join(' '));
      function run(k) {
        if (k >= queries.length) return Promise.resolve(null);
        return fetchList(queries[k]).then(function (list) { return pick(list) || run(k + 1); });
      }
      run(0)
        .then(function (best) {
          catMatch[pid] = best
            ? { state: 'ready', h: best.h, title: best.title, spots: (best.spots || []).slice(), cat: best.cat || '' }
            : { state: 'none' };
        })
        .catch(function () { catMatch[pid] = { state: 'none' }; })
        .then(function () {
          if (state.draft && String(state.draft.pid) === pid && state.modal) { grabModal(); renderModal(); }
          else if (state.step === 3) { grabInputs(); render(); }
        });
    }
    // Print locations for a product already in the store: its catalog
    // original's real spots when we found it, then its category's list, then
    // everything we print.
    function catGuess(sp) {
      var keys = Object.keys(cfg.placements || {});
      var bits = [sp.type].concat(sp.tags || []);
      for (var i = 0; i < bits.length; i++) {
        var n = norm(String(bits[i] || '').replace(/\s*-\s*ml\s*$/i, ''));
        if (!n) continue;
        for (var k = 0; k < keys.length; k++) if (norm(keys[k]) === n) return keys[k];
      }
      // No usable tag: read the product's name.
      var nm = ' ' + norm(sp.title) + ' ';
      var words = [
        [['polos', 'polo'], /\s(polo|polos)\s/],
        [['headwear'], /\s(cap|caps|hat|hats|beanie|beanies|visor|snapback|trucker)\s/],
        [['t shirts', 't shirt'], /\s(t shirt|t shirts|tshirt|tee|tees)\s/],
        [['outerwear fleece'], /\s(hoodie|sweatshirt|jacket|fleece|vest|pullover|quarter zip|crewneck)\s/],
        [['bags backpacks'], /\s(bag|bags|backpack|tote|duffel|duffle)\s/],
        [['drinkware'], /\s(tumbler|bottle|mug|drinkware|cup)\s/]
      ];
      for (var w = 0; w < words.length; w++) {
        if (!words[w][1].test(nm)) continue;
        for (var q = 0; q < keys.length; q++) if (words[w][0].indexOf(norm(keys[q])) > -1) return keys[q];
      }
      return '';
    }
    function spotsForStore(pid) {
      var m = catMatch[String(pid)];
      if (m && m.state === 'ready') {
        if (m.spots.length) return m.spots;
        if (m.cat && (cfg.placements || {})[m.cat]) return cfg.placements[m.cat];
      }
      // No catalog original found: use the product's own category (a "T Shirts"
      // tag) before ever offering every location we print.
      var sp = storeProduct(pid);
      var g = sp ? catGuess(sp) : '';
      if (g) return cfg.placements[g];
      return placementsFor(null);
    }
    function spotsNote(pid) {
      var m = catMatch[String(pid)];
      if (!m || m.state === 'loading') return '<p class="mlsr-hint">Checking where this product can be printed…</p>';
      if (m.state === 'ready' && m.spots.length) return '<p class="mlsr-hint">Print locations for ' + esc(m.title) + '.</p>';
      return '';
    }

    /* -- locations ---------------------------------------------------------------
       Every change carries a list of locations, each with its own print spot and
       its own artwork. c.placement and c.logoId mirror the first one, so older
       drafts and any code that only wants the main location keep working. */
    function ensureLocs(c) {
      if (!Array.isArray(c.locs) || !c.locs.length) c.locs = [{ placement: c.placement || '', logoId: c.logoId || '' }];
      return c;
    }
    function syncFirst(c) {
      ensureLocs(c);
      c.placement = c.locs[0].placement || '';
      c.logoId = c.locs[0].logoId || '';
    }
    var LOC_RE = /^(draft|c(\d+)):(\d+)$/;
    function locTarget(ctx) {
      var m = LOC_RE.exec(ctx);
      if (!m) return null;
      var c = m[1] === 'draft' ? state.draft : state.data.changes[+m[2]];
      if (!c) return null;
      ensureLocs(c);
      return { c: c, j: +m[3], loc: c.locs[+m[3]], draft: m[1] === 'draft' };
    }
    // Where a change's artwork can go, by what the change is.
    function spotsFor(c) {
      if (c.type === 'add') return placementsFor(c);
      if (c.type === 'swap') return placementsFor(c.to);
      return spotsForStore(c.pid);
    }
    function locErrors(c, e, lp, pp) {
      ensureLocs(c);
      c.locs.forEach(function (l, j) {
        var need = c.type !== 'swap' || j > 0;
        if (l.logoId && !logoById(l.logoId)) e[lp + j] = 'Upload this artwork again, we could not keep the file after the page reloaded.';
        else if (need && !l.logoId) e[lp + j] = 'Upload the artwork for this location.';
        if (!l.placement) e[pp + j] = 'Choose where this one goes.';
      });
    }

    function logoInUse(id) {
      var hit = false;
      function chk(c) { ensureLocs(c).locs.forEach(function (l) { if (l.logoId === id) hit = true; }); }
      state.data.changes.forEach(chk);
      if (state.draft) chk(state.draft);
      return hit;
    }
    /* -- saved artwork files -----------------------------------------------------
       A File cannot go in localStorage, so every uploaded file is also kept in
       IndexedDB, in this browser. After a refresh they come back with their
       thumbnails and stay attached to the right product. Where the browser
       blocks IndexedDB (some private windows) every call here fails quietly and
       the wizard behaves as before, asking for the file again. */
    var IDB_NAME = 'mlsuFiles', IDB_STORE = 'files';
    function idbRun(mode, fn) {
      return new Promise(function (resolve, reject) {
        var rq;
        try { rq = indexedDB.open(IDB_NAME, 1); } catch (e) { return reject(e); }
        rq.onupgradeneeded = function () { rq.result.createObjectStore(IDB_STORE, { keyPath: 'id' }); };
        rq.onerror = function () { reject(rq.error); };
        rq.onsuccess = function () {
          var db = rq.result, out;
          try {
            var tx = db.transaction(IDB_STORE, mode);
            out = fn(tx.objectStore(IDB_STORE));
            tx.oncomplete = function () { db.close(); resolve(out && out.result); };
            tx.onerror = tx.onabort = function () { db.close(); reject(tx.error); };
          } catch (e) { try { db.close(); } catch (e2) {} reject(e); }
        };
      });
    }
    function quiet() {}
    function fileSave(l) {
      if (!l || !l.file) return;
      idbRun('readwrite', function (st) {
        return st.put({ id: l.id, name: l.name, type: l.file.type || '', blob: l.file, t: Date.now() });
      }).catch(quiet);
    }
    function fileDel(id) { idbRun('readwrite', function (st) { return st.delete(id); }).catch(quiet); }
    function fileClear() { idbRun('readwrite', function (st) { return st.clear(); }).catch(quiet); }
    function restoreFiles() {
      idbRun('readonly', function (st) { return st.getAll(); }).then(function (rows) {
        (rows || []).forEach(function (r) {
          if (!r || !r.blob || logoById(r.id)) return;
          var f = (typeof File !== 'undefined' && r.blob instanceof File) ? r.blob : new File([r.blob], r.name, { type: r.type || '' });
          var l = { id: r.id, file: f, name: r.name, previewUrl: '' };
          if (/^image\/(png|jpe?g|gif|webp|svg\+xml)$/.test(f.type)) {
            try { l.previewUrl = URL.createObjectURL(f); } catch (e) {}
          }
          state.logos.push(l);
        });
        // Anything no change points at was left behind by an abandoned draft.
        state.logos.filter(function (l) { return !logoInUse(l.id); }).forEach(function (l) { dropLogo(l.id); });
        if (state.logos.length) render();
      }).catch(quiet);
    }

    function dropLogo(id) {
      var k = logoIndex(id);
      if (k < 0) return;
      fileDel(id);
      var gone = state.logos.splice(k, 1)[0];
      try { if (gone.previewUrl) URL.revokeObjectURL(gone.previewUrl); } catch (e) {}
    }

    function logoById(id) {
      return state.logos.filter(function (l) { return l.id === id; })[0] || null;
    }
    function logoIndex(id) {
      for (var i = 0; i < state.logos.length; i++) if (state.logos[i].id === id) return i;
      return -1;
    }
    function logoName(id) {
      var l = logoById(id);
      return l ? 'Logo ' + (logoIndex(id) + 1) + ' (' + l.name + ')' : '';
    }

    // Where a logo can go is a property of the catalog product when we know it
    // (merchloop.decoration_spots, carried in the picker's sidecar data), and of
    // its category otherwise. Same rule as the store request wizard.
    function placementsFor(p) {
      if (p && p.spots && p.spots.length) return p.spots;
      var m = cfg.placements || {};
      if (p && p.cat && m[p.cat]) return m[p.cat];
      return cfg.default_placements && cfg.default_placements.length
        ? cfg.default_placements : ['Left Chest', 'Full Front', 'Full Back'];
    }
    function allPlacements() {
      // For a product already in the store we do not know its decoration spots,
      // so offer every location we print, common ones first.
      var seen = {}, out = [];
      var lists = [cfg.default_placements || []];
      Object.keys(cfg.placements || {}).forEach(function (k) { lists.push(cfg.placements[k]); });
      lists.forEach(function (l) {
        (l || []).forEach(function (v) { if (!seen[v]) { seen[v] = 1; out.push(v); } });
      });
      return out;
    }

    function catalogItem(p) {
      return {
        h: p.h, title: p.title, img: p.img || '', url: p.url || ('/products/' + p.h),
        cat: p.cat || '', brand: p.brand || '', spots: (p.spots || []).slice(),
        colors: (p.colors || []).slice()
      };
    }

    /* -- draft ----------------------------------------------------------------- */

    function saveDraft() {
      state.data.changes.forEach(syncFirst);
      try {
        localStorage.setItem(DRAFT_KEY, JSON.stringify({
          t: Date.now(), step: state.step, started: state.started, data: state.data
        }));
      } catch (e) {}
    }
    function clearDraft() { try { localStorage.removeItem(DRAFT_KEY); } catch (e) {} }
    function readDraft() {
      try {
        var d = JSON.parse(localStorage.getItem(DRAFT_KEY) || 'null');
        if (!d || !d.data) return null;
        if (Date.now() - (d.t || 0) > 1000 * 60 * 60 * 24 * 7) return null;
        return d;
      } catch (e) { return null; }
    }

    /* -- the store index -------------------------------------------------------
       The same index the Find Your Store page and the request tray search, Title|
       handle|alt per line, loaded on first focus. The handle is left out when it
       is the title lowercased with punctuation removed. */
    var STORES = [], idxState = 0, idxWait = [];
    function parseIndex() {
      var raw = window.MLStores || [], seen = {};
      for (var i = 0; i < raw.length; i++) {
        String(raw[i]).split('\n').forEach(function (line) {
          if (!line) return;
          var p = line.split('|');
          var title = (p[0] || '').trim();
          if (!title) return;
          var h = (p[1] || '').trim() || title.toLowerCase().replace(/[^a-z0-9]/g, '');
          if (seen[h]) return;
          seen[h] = 1;
          STORES.push({ t: title, a: (p[2] || '').trim(), h: h });
        });
      }
    }
    function loadIndex() {
      return new Promise(function (resolve) {
        if (idxState === 2 || idxState === 3) return resolve();
        if (idxState === 1) return idxWait.push(resolve);
        var urls = cfg.store_index || [];
        if (window.MLStores && window.MLStores.length >= urls.length && urls.length) {
          parseIndex(); idxState = STORES.length ? 2 : 3; return resolve();
        }
        if (!urls.length) { idxState = 3; return resolve(); }
        idxState = 1;
        var left = urls.length;
        var done = function () {
          if (--left > 0) return;
          parseIndex();
          idxState = STORES.length ? 2 : 3;
          resolve();
          idxWait.splice(0).forEach(function (f) { f(); });
        };
        // A part that fails gets two more tries. Freshly published index parts
        // can answer 502 from a cold CDN edge, and a missing part silently drops
        // a sixth of our stores from the search.
        function add(u, tries) {
          var s = document.createElement('script');
          s.src = u; s.async = true; s.onload = done;
          s.onerror = function () {
            s.remove();
            if (tries < 2) setTimeout(function () { add(u, tries + 1); }, 400 * (tries + 1));
            else done();
          };
          document.head.appendChild(s);
        }
        urls.forEach(function (u) { add(u, 0); });
      });
    }
    function searchStores(q, limit) {
      var tight = norm(q).replace(/ /g, '');
      if (tight.length < 2) return [];
      var hits = [];
      for (var i = 0; i < STORES.length; i++) {
        var s = STORES[i];
        var nt = norm(s.t), tt = nt.replace(/ /g, ''), score = 0;
        if (tt === tight) score = 1000;
        else if (tt.indexOf(tight) === 0) score = 800 - Math.min(nt.length, 60);
        if (!score) {
          var w = words(s.t + ' ' + s.a);
          for (var j = 0; j < w.length; j++) {
            if (w[j].indexOf(tight) === 0) { score = 620 - Math.min(j, 20) * 10; break; }
          }
        }
        if (!score && (tt + norm(s.a).replace(/ /g, '')).indexOf(tight) !== -1) score = 420;
        if (score) hits.push([score, s]);
      }
      hits.sort(function (a, b) { return b[0] - a[0] || a[1].t.length - b[1].t.length; });
      return hits.slice(0, limit || 6).map(function (h) { return h[1]; });
    }

    /* -- the store's live products --------------------------------------------- */

    var loadSeq = 0;
    function loadStoreProducts() {
      var store = state.data.store;
      if (!store) return;
      var seq = ++loadSeq;
      state.productsState = 'loading';
      state.products = null;
      paintStoreCard();
      var all = [];
      function page(n) {
        var url = '/collections/' + encodeURIComponent(store.handle) + '?view=mlsustore&page=' + n;
        // No Accept: application/json header on purpose. Sent with one, Shopify
        // ignores ?view= and answers with its own collection JSON, which has no
        // products in it, so every store looked empty.
        return fetch(url, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
          .then(function (t) {
            var j = JSON.parse(t);
            if (!j || !Array.isArray(j.products)) throw new Error('unexpected store feed');
            if (seq !== loadSeq) return;
            if (j.title && n === 1) store.title = j.title;
            all = all.concat(j.products || []);
            // Ten pages is 500 products, far beyond any store we run. The cap is
            // only there so a broken response can never loop.
            if (j.pages && n < j.pages && n < 10) return page(n + 1);
          });
      }
      page(1).then(function () {
        if (seq !== loadSeq) return;
        state.products = all;
        state.productsState = 'ready';
        // A revision on a product that is no longer live cannot be actioned.
        state.data.changes = state.data.changes.filter(function (c) {
          return c.type === 'add' || !!storeProduct(c.pid);
        });
        saveDraft();
        afterProducts();
      }).catch(function (e) {
        if (seq !== loadSeq) return;
        if (window.console) console.warn('[mlsu] could not load store products', e);
        state.productsState = 'error';
        afterProducts();
      });
    }
    function afterProducts() {
      if (state.step === 1) paintStoreCard();
      else if (state.step === 2 && state.view === 'revise') render();
    }

    /* -- picker ------------------------------------------------------------------
       One picker, mounted once and kept for the life of the page. mlsr-catalog.js
       binds its quick view popup to the first picker that opens it, so a second
       mount would leave the popup toggling through a dead instance. Instead the
       same element is moved into each render, and the api it was given dispatches
       on which view is showing: adding products, or choosing a swap. */
    var pickerEl = null, pickerListeners = [];
    var pickerApi = {
      isSelected: function (h) {
        if (state.view === 'swap') return !!(state.draft && state.draft.to && state.draft.to.h === h);
        return changes('add').some(function (c) { return c.h === h; });
      },
      toggle: function (p) {
        if (state.view === 'swap') return chooseSwap(p);
        toggleAdd(p);
      },
      onSelectionChange: function (cb) { pickerListeners.push(cb); }
    };
    function notifyPicker() { pickerListeners.forEach(function (f) { try { f(); } catch (e) {} }); }

    function mountPicker() {
      var slot = root.querySelector('[data-mlsu-cathost]');
      if (!slot) return;
      if (!window.MLSRCatalog) {
        slot.innerHTML = '<div class="mlsr-state"><h3>Catalog unavailable</h3><p>Please refresh the page.</p></div>';
        return;
      }
      if (!pickerEl) {
        pickerEl = document.createElement('div');
        pickerEl.className = 'mlsr-cat';
        pickerApi.baseUrl = '/collections/' + cfg.catalog_handle;
        pickerApi.packs = cfg.packs || [];
        pickerApi.popularTag = cfg.popular_tag || '';
        pickerApi.catalogTag = cfg.catalog_tag || '';
        pickerApi.vendorFallback = cfg.vendor_fallback || 'Merchloop';
        slot.appendChild(pickerEl);
        window.MLSRCatalog.mount(pickerEl, pickerApi);
      } else {
        slot.appendChild(pickerEl);
        notifyPicker();
      }
    }
    function closeQuickView() {
      var m = document.querySelector('[data-mlsr-qvmodal].is-open');
      if (m) { m.classList.remove('is-open'); m.removeAttribute('data-handle'); }
      document.body.style.overflow = '';
    }

    /* -- color photos ------------------------------------------------------------
       The picker's feed only carries color names, so the photo for each color is
       read from the product's own .js feed: the featured image of the first
       variant in that color. Cached per catalog handle. */
    var colorImgs = {};
    function sized(src, w) {
      return String(src || '').replace(/(\.[a-z0-9]+)(\?|$)/i, '_' + w + 'x$1$2');
    }
    function loadColorImgs(h) {
      if (!h || colorImgs[h]) return;
      colorImgs[h] = { state: 'loading', map: {} };
      fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (p) {
          var ci = -1;
          (p.options || []).forEach(function (o, i) { if (ci < 0 && /colou?r|colorway/i.test(o.name || '')) ci = i; });
          if (ci < 0) ci = 0;
          var key = 'option' + (ci + 1), map = {};
          (p.variants || []).forEach(function (v) {
            var val = v[key], src = v.featured_image && v.featured_image.src;
            if (val && src && !map[val]) map[val] = src;
          });
          colorImgs[h] = { state: Object.keys(map).length ? 'ready' : 'none', map: map };
        })
        .catch(function () { colorImgs[h] = { state: 'none', map: {} }; })
        .then(function () {
          if (state.draft && colorTarget(state.draft).h === h && state.modal) { grabModal(); renderModal(); if (state.zoom) renderZoom(); }
        });
    }
    // The product whose colors are being chosen: the new product on an add, the
    // replacement on a swap.
    function colorTarget(d) {
      if (!d) return { h: '', title: '', avail: [] };
      if (d.type === 'swap') return d.to ? { h: d.to.h, title: d.to.title, avail: d.to.colors || [] } : { h: '', title: '', avail: [] };
      return { h: d.h, title: d.title, avail: d.available || [] };
    }
    function colorPhoto(h, color) {
      var c = colorImgs[h];
      return c && c.state === 'ready' && c.map[color] ? c.map[color] : '';
    }
    function zoomHost() {
      var z = document.querySelector('[data-mlsu-zoom]');
      if (z) return z;
      z = document.createElement('div');
      z.className = 'mlsu-zoom mlsr';
      z.setAttribute('data-mlsu-zoom', '');
      z.setAttribute('role', 'dialog');
      z.setAttribute('aria-modal', 'true');
      document.body.appendChild(z);
      z.addEventListener('click', onClick);
      return z;
    }
    function zoomList() {
      var d = state.draft;
      if (!d) return [];
      var ct = colorTarget(d);
      return ct.avail.filter(function (c) { return !!colorPhoto(ct.h, c); });
    }
    function renderZoom() {
      var z = zoomHost(), d = state.draft;
      if (!state.zoom || !d) { z.classList.remove('is-open'); z.innerHTML = ''; return; }
      var list = zoomList(), color = state.zoom.color;
      var ct = colorTarget(d);
      var src = colorPhoto(ct.h, color);
      if (!src) { state.zoom = null; z.classList.remove('is-open'); z.innerHTML = ''; return; }
      var on = (d.colors || []).indexOf(color) !== -1, multi = list.length > 1;
      z.innerHTML =
        '<div class="mlsu-zoom__scrim" data-act="zoom-close"></div>' +
        '<div class="mlsu-zoom__box">' +
          '<button type="button" class="mlsr-qv__x mlsu-zoom__x" data-act="zoom-close" aria-label="Close">' + I.x + '</button>' +
          '<div class="mlsu-zoom__stage">' +
            (multi ? '<button type="button" class="mlsu-zoom__nav mlsu-zoom__nav--l" data-act="zoom-step" data-d="-1" aria-label="Previous color">' + I.chevL + '</button>' : '') +
            '<img class="mlsu-zoom__img" src="' + esc(sized(src, 1000)) + '" alt="' + esc(ct.title + ', ' + color) + '">' +
            (multi ? '<button type="button" class="mlsu-zoom__nav mlsu-zoom__nav--r" data-act="zoom-step" data-d="1" aria-label="Next color">' + I.chevR + '</button>' : '') +
          '</div>' +
          '<div class="mlsu-zoom__cap"><span><b>' + esc(color) + '</b><em>' + esc(ct.title) + '</em></span>' +
            '<button type="button" class="mlsr-btn ' + (on ? 'mlsr-btn--outline' : 'mlsr-btn--primary') + '" data-act="dcolor" data-color="' + esc(color) + '">' +
              (on ? I.check + ' Selected' : 'Select this color') + '</button></div>' +
        '</div>';
      z.classList.add('is-open');
    }
    function closeZoom() { state.zoom = null; renderZoom(); }

    function toggleAdd(p) {
      var i = -1;
      state.data.changes.forEach(function (c, k) { if (c.type === 'add' && c.h === p.h) i = k; });
      if (i > -1) {
        state.data.changes.splice(i, 1);
        state.capNote = '';
        saveDraft(); notifyPicker(); paintBar();
        return;
      }
      if (state.data.changes.length >= MAX_CHANGES) {
        state.capNote = 'One request can carry up to ' + MAX_CHANGES + ' changes. Send this one and start another for the rest.';
        paintBar(); return;
      }
      closeQuickView();
      openAdd(catalogItem(p), null);
    }
    // Adding a product opens the same panel as revising one: colors, where the
    // artwork goes, the artwork itself. Nothing joins the list until it is saved.
    function openAdd(it, existing) {
      if (existing) state.draft = JSON.parse(JSON.stringify(existing));
      else state.draft = {
        id: uid(), type: 'add',
        h: it.h, title: it.title, img: it.img, url: it.url, cat: it.cat, brand: it.brand,
        spots: it.spots, available: it.colors,
        colors: it.colors[0] ? [it.colors[0]] : [],
        placement: '', logoId: '', notes: '',
        locs: [{ placement: '', logoId: '' }]
      };
      ensureLocs(state.draft);
      loadColorImgs(state.draft.h);
      state.capNote = '';
      Object.keys(state.errors).forEach(function (k) { if (/^draft/.test(k)) delete state.errors[k]; });
      state.modal = state.draft.id;
      renderModal();
    }

    function chooseSwap(p) {
      if (!state.draft) return;
      state.draft.to = catalogItem(p);
      state.draft.colors = state.draft.to.colors[0] ? [state.draft.to.colors[0]] : [];
      ensureLocs(state.draft);
      state.draft.locs = [{ placement: '', logoId: state.draft.locs[0].logoId || '' }];
      syncFirst(state.draft);
      delete state.errors.draftTo;
      loadColorImgs(state.draft.to.h);
      closeQuickView();
      state.view = 'revise';
      state.modal = state.draft.pid;
      render();
      scrollTop();
    }

    /* -- navigation -------------------------------------------------------------- */

    function goTo(n) {
      state.step = n;
      state.view = 'hub';
      state.modal = null;
      root.setAttribute('data-step', String(n));
      saveDraft();
      render();
      scrollTop();
    }
    function setView(v) {
      state.view = v;
      root.setAttribute('data-view', v);
      render();
      scrollTop();
    }

    function validateStep(n) {
      var e = {}, d = state.data;
      if (n === 1) {
        if (!d.store) e.store = 'Pick your store from the list as you type its name.';
        if (!d.firstName.trim()) e.firstName = 'Add your first name.';
        if (!d.lastName.trim()) e.lastName = 'Add your last name.';
        if (!d.email.trim()) e.email = 'Add your work email.';
        else if (!emailOk(d.email)) e.email = 'That email does not look right, check it over.';
        if (!d.phone.trim()) e.phone = 'Add a phone number, it is how we reach you fastest.';
        else if (!phoneOk(d.phone)) e.phone = 'That phone number looks short, check it over.';
      }
      if (n === 2) {
        if (!d.changes.length) e.changes = 'Add at least one change. Pick new products, or choose something in your store to revise.';
      }
      if (n === 3) {
        d.changes.forEach(function (c) {
          if (c.type === 'swap' && !c.to) { e['to_' + c.id] = 'Choose the replacement product.'; return; }
          locErrors(c, e, 'logo_' + c.id + '_', 'place_' + c.id + '_');
        });
      }
      state.errors = e;
      return !Object.keys(e).length;
    }
    function next() {
      grabInputs();
      if (!validateStep(state.step)) { render(); focusFirstError(); return; }
      if (state.step < 4) goTo(state.step + 1);
    }
    function back() {
      if (state.step === 2 && state.view !== 'hub') return setView('hub');
      if (state.step > 1) goTo(state.step - 1);
      else { state.started = false; saveDraft(); render(); scrollTop(); }
    }
    function focusFirstError() {
      var bad = root.querySelector('.is-invalid input, .is-invalid select, .is-invalid textarea, .mlsu-ccard.is-invalid, .mlsr-err');
      if (bad && bad.scrollIntoView) bad.scrollIntoView({ block: 'center', behavior: 'smooth' });
      if (bad && bad.focus) try { bad.focus({ preventScroll: true }); } catch (e) {}
    }

    /* -- render -------------------------------------------------------------------- */

    function renderTracker() {
      if (!state.started) { elTrack.innerHTML = ''; elTrack.hidden = true; return; }
      elTrack.hidden = false;
      elTrack.innerHTML = '<ol class="mlsr-track">' + stepNames().map(function (n, i) {
        var idx = i + 1;
        var cls = idx < state.step ? 'is-done' : (idx === state.step ? 'is-now' : '');
        return '<li class="mlsr-track__step ' + cls + '">' +
          '<span class="mlsr-track__dot">' + (idx < state.step ? I.check : idx) + '</span>' +
          '<span class="mlsr-track__label">' + esc(n) + '</span></li>';
      }).join('') + '</ol>';
    }

    function render() {
      renderTracker();
      root.setAttribute('data-step', String(state.step));
      root.setAttribute('data-view', state.step === 2 ? state.view : '');
      var html;
      if (!state.started) html = welcome();
      else if (state.step === 1) html = step1();
      else if (state.step === 2) {
        if (state.view === 'add') html = viewAdd();
        else if (state.view === 'revise') html = viewRevise();
        else if (state.view === 'swap') html = viewSwap();
        else html = viewHub();
      }
      else if (state.step === 3) html = step3();
      else html = step4();

      var keepY = window.pageYOffset || 0;
      elSteps.innerHTML = '<div class="mlsr__step is-active">' + html + '</div>';
      if (keepY) window.scrollTo(0, Math.min(keepY, Math.max(0, document.documentElement.scrollHeight - window.innerHeight)));

      if (state.started && state.step === 2 && (state.view === 'add' || state.view === 'swap')) mountPicker();
      if (state.started && state.step === 2 && (state.view === 'add' || state.view === 'revise')) paintBar();
      if (state.started && state.step === 1) paintStoreCard();
      renderModal();
    }

    function err(k) { return state.errors[k] ? '<p class="mlsr-err">' + esc(state.errors[k]) + '</p>' : ''; }
    function fcls(k) { return 'mlsr-field' + (state.errors[k] ? ' is-invalid' : ''); }
    function foot(label, opts) {
      opts = opts || {};
      return '<div class="mlsr__foot">' +
        '<button type="button" class="mlsr-btn mlsr-btn--outline" data-act="back">' + I.chevL + ' Back</button>' +
        '<button type="button" class="mlsr-btn mlsr-btn--primary" data-act="' + (opts.act || 'next') + '"' +
          (opts.disabled ? ' disabled' : '') + '>' + label + (opts.noChev ? '' : ' ' + I.chevR) + '</button>' +
      '</div>';
    }
    function helpBar() {
      var bits = [];
      if (cfg.help_meeting_url) {
        bits.push('<a class="mlsr-help__a" href="' + esc(cfg.help_meeting_url) + '" target="_blank" rel="noopener">' +
          I.cal + ' Book a 15 minute call</a>');
      }
      bits.push('<button type="button" class="mlsr-help__a" data-act="chat">' + I.chat + ' Chat with us</button>');
      return '<div class="mlsr-help"><span class="mlsr-help__t">Stuck, or want a hand?</span>' + bits.join('') + '</div>';
    }
    function aside(title, sub, notes) {
      return '<div class="mlsr-2col__aside">' +
        '<div class="mlsr__head"><h2>' + title + '</h2><p class="mlsr__sub">' + sub + '</p></div>' +
        (notes && notes.length ? '<ul class="mlsr-aside__notes">' + notes.map(function (n) {
          return '<li>' + I.check + '<span>' + n + '</span></li>';
        }).join('') + '</ul>' : '') +
      '</div>';
    }
    function twoCol(a, m) { return '<div class="mlsr-2col">' + a + '<div class="mlsr-2col__main">' + m + '</div></div>'; }
    function thumb(src, cls) {
      return src
        ? '<img class="' + cls + '" src="' + esc(src) + '" alt="" loading="lazy">'
        : '<span class="' + cls + ' mlsu-noimg"></span>';
    }

    /* ---- welcome ------------------------------------------------------------------ */

    function welcome() {
      var tiles = [
        ['Add new products', 'Pick from the full Merchloop catalog and we add them to your store.', 'teal'],
        ['New artwork', 'Put a new or updated logo on something you already sell.', 'navy'],
        ['Swap a product', 'Replace a product in your store with a different one from the catalog.', 'amber']
      ].map(function (t, i) {
        return '<li class="mlsr-feat mlsr-feat--' + t[2] + '">' +
          '<span class="mlsr-feat__art"><span class="mlsr-feat__n">' + (i + 1) + '</span></span>' +
          '<span class="mlsr-feat__t"><b>' + esc(t[0]) + '</b><span class="mlsr-feat__rule"></span><em>' + esc(t[1]) + '</em></span></li>';
      }).join('');
      var meta = [
        [I.clock, 'A few minutes. Mix any of these in one request.'],
        [I.check, 'Nothing changes in your store until we have built and checked it.'],
        [I.chat, 'Stuck at any point? Book a call or chat with us from any step.']
      ].map(function (r) { return '<li>' + r[0] + '<span>' + r[1] + '</span></li>'; }).join('');
      return '<div class="mlsr-welcome">' +
        '<div class="mlsr-welcome__cols">' +
          '<div class="mlsr-welcome__pitch">' +
            '<p class="mlsr-welcome__eyebrow">' + esc(cfg.welcome_eyebrow || 'Update your store') + '</p>' +
            '<h2>' + esc(cfg.welcome_heading || 'Change what\'s in your company store') + '</h2>' +
            '<p class="mlsr__sub mlsr__sub--lg">' + esc(cfg.welcome_body || '') + '</p>' +
            '<ul class="mlsr-welcome__meta">' + meta + '</ul>' +
            '<div class="mlsr-welcome__cta">' +
              '<button type="button" class="mlsr-btn mlsr-btn--primary mlsr-btn--hero" data-act="start">' +
                esc(cfg.welcome_cta || 'Find my store') + ' ' + I.chevR + '</button>' +
            '</div>' +
            '<p class="mlsu-welcome__alt">Don\'t have a store with us yet? <a href="' + esc(cfg.request_url) + '">Start a new store request</a>.</p>' +
          '</div>' +
          '<div class="mlsr-welcome__right">' +
            '<p class="mlsr-welcome__st">What you can do here</p>' +
            '<ol class="mlsr-welcome__steps mlsr-feats">' + tiles + '</ol>' +
          '</div>' +
        '</div>' + helpBar() +
      '</div>';
    }

    /* ---- step 1: your store ---------------------------------------------------------- */

    function step1() {
      var d = state.data;
      function f(id, key, label, ph, type, extra) {
        return '<div class="' + fcls(key) + '">' +
          '<label class="mlsr-label" for="' + id + '">' + label + '<span class="req">*</span></label>' +
          '<input class="mlsr-input" id="' + id + '" type="' + type + '" placeholder="' + ph + '" value="' +
          esc(d[key]) + '" data-bind="' + key + '"' + (extra || '') + '>' + err(key) + '</div>';
      }
      return twoCol(
        aside('Your store', 'Find the store we run for you, and tell us who is asking.', [
          'Start typing your company or store name and pick it from the list.',
          'We load the products that are live in your store right now, so you can choose what to change.',
          'We reply to the email you give here.'
        ]),
        '<div class="mlsr-fields">' +
          '<div class="' + fcls('store') + ' mlsu-storefield">' +
            '<label class="mlsr-label" for="mlsu-store">Your store<span class="req">*</span></label>' +
            '<div class="mlsu-storebox"' + (d.store ? ' hidden' : '') + '>' +
              '<span class="mlsu-storebox__ico">' + I.search + '</span>' +
              '<input class="mlsr-input mlsu-storebox__in" id="mlsu-store" type="text" autocomplete="off" ' +
                'placeholder="Company or store name" data-mlsu-storeq role="combobox" aria-expanded="false" aria-controls="mlsu-sugg">' +
            '</div>' +
            '<div class="mlsu-sugg" id="mlsu-sugg" role="listbox" data-mlsu-sugg hidden></div>' +
            '<div class="mlsu-nostore" data-mlsu-nostore hidden>' +
              '<p data-mlsu-nostore-line></p>' +
              '<p>Check the spelling or try a shorter name. No store yet? <a href="' + esc(cfg.request_url) + '">Start a new store request</a>.</p>' +
            '</div>' +
            '<div data-mlsu-storecard></div>' +
            err('store') +
          '</div>' +
          '<div class="mlsr-row mlsr-row--2">' +
            f('mlsu-fn', 'firstName', 'First Name', 'Jane', 'text', ' autocomplete="given-name"') +
            f('mlsu-ln', 'lastName', 'Last Name', 'Doe', 'text', ' autocomplete="family-name"') +
          '</div>' +
          '<div class="mlsr-row mlsr-row--2">' +
            f('mlsu-em', 'email', 'Work Email', 'jane@acme.com', 'email', ' autocomplete="email"') +
            f('mlsu-ph', 'phone', 'Phone Number', '(555) 123-4567', 'tel', ' autocomplete="tel"') +
          '</div>' +
        '</div>' + foot('Continue')
      ) + helpBar();
    }

    function storeCardHtml() {
      var s = state.data.store;
      if (!s) return '';
      var status;
      if (state.productsState === 'loading') status = '<span class="mlsr-spin"></span> Loading your products…';
      else if (state.productsState === 'ready') {
        var n = (state.products || []).length;
        status = I.check + ' ' + n + (n === 1 ? ' product' : ' products') + ' live in your store';
      } else if (state.productsState === 'error') {
        status = 'We could not load your products. <button type="button" class="mlsu-linkbtn" data-act="store-retry">Try again</button>';
      } else status = '';
      return '<div class="mlsu-storecard">' +
        '<span class="mlsu-storecard__ico">' + I.store + '</span>' +
        '<span class="mlsu-storecard__t"><b>' + esc(s.title) + '</b>' +
          '<em class="mlsu-storecard__s mlsu-storecard__s--' + state.productsState + '">' + status + '</em></span>' +
        '<button type="button" class="mlsu-linkbtn" data-act="store-clear">Not this store</button>' +
      '</div>';
    }
    function paintStoreCard() {
      var el = root.querySelector('[data-mlsu-storecard]');
      if (el) el.innerHTML = storeCardHtml();
      var box = root.querySelector('.mlsu-storebox');
      if (box) box.hidden = !!state.data.store;
    }

    var suggTimer = null;
    function onStoreInput(v) {
      clearTimeout(suggTimer);
      suggTimer = setTimeout(function () { loadIndex().then(function () { paintSugg(v); }); }, 160);
    }
    function paintSugg(v) {
      var box = root.querySelector('[data-mlsu-sugg]');
      var none = root.querySelector('[data-mlsu-nostore]');
      var input = root.querySelector('[data-mlsu-storeq]');
      if (!box) return;
      var q = String(v || '').trim();
      var hits = q ? searchStores(q, 6) : [];
      if (hits.length) {
        box.innerHTML = hits.map(function (s, i) {
          return '<button type="button" role="option" class="mlsu-sugg__o" data-act="store-pick" data-i="' + i + '">' +
            I.store + '<span>' + esc(s.t) + '</span></button>';
        }).join('');
        box.__hits = hits;
        box.hidden = false;
        if (none) none.hidden = true;
      } else {
        box.hidden = true; box.innerHTML = '';
        if (none) {
          if (q.length >= 3 && idxState !== 3) {
            none.querySelector('[data-mlsu-nostore-line]').textContent = 'We cannot find “' + q + '” on our list of stores.';
            none.hidden = false;
          } else if (idxState === 3 && q.length >= 3) {
            none.querySelector('[data-mlsu-nostore-line]').textContent = 'Our store list did not load. Refresh the page, or chat with us.';
            none.hidden = false;
          } else none.hidden = true;
        }
      }
      if (input) input.setAttribute('aria-expanded', hits.length ? 'true' : 'false');
    }
    function pickStore(s) {
      var prev = state.data.store;
      state.data.store = { title: s.t, handle: s.h };
      // A different store means a different product list, so revisions made
      // against the old one cannot carry over. New products can.
      if (prev && prev.handle !== s.h) {
        state.data.changes = state.data.changes.filter(function (c) { return c.type === 'add'; });
      }
      delete state.errors.store;
      var box = root.querySelector('[data-mlsu-sugg]');
      if (box) { box.hidden = true; box.innerHTML = ''; }
      var f = root.querySelector('.mlsu-storefield');
      if (f) { f.classList.remove('is-invalid'); var e = f.querySelector('.mlsr-err'); if (e) e.remove(); }
      saveDraft();
      loadStoreProducts();
    }

    /* ---- step 2: hub ------------------------------------------------------------------ */

    function viewHub() {
      var s = state.data.store || { title: 'your store' };
      var nAdd = changes('add').length;
      var nRev = changes('artwork').length + changes('swap').length;
      function path(view, icon, title, body, n, nLabel, hue) {
        return '<button type="button" class="mlsu-path mlsu-path--' + hue + '" data-act="view" data-view="' + view + '">' +
          '<span class="mlsu-path__ico">' + icon + '</span>' +
          '<span class="mlsu-path__t"><b>' + title + '</b><em>' + body + '</em></span>' +
          '<span class="mlsu-path__n' + (n ? ' is-on' : '') + '">' + (n ? n + ' ' + nLabel : 'Start') + ' ' + I.chevR + '</span>' +
        '</button>';
      }
      return '<div class="mlsr__head mlsu-head">' +
          '<h2>What would you like to change?</h2>' +
          '<p class="mlsr__sub">Build your list for <b>' + esc(s.title) + '</b>. Mix and match, then send it all at once.</p>' +
        '</div>' +
        '<div class="mlsu-paths">' +
          path('add', I.bag, 'Add new products', 'Pick products from the Merchloop catalog and we add them to your store with your logo.', nAdd, 'added', 'teal') +
          path('revise', I.edit, 'Revise existing products', 'Change the artwork on something in your store, or swap it for a different product. The current version comes down while we build the new one.', nRev, nRev === 1 ? 'revision' : 'revisions', 'navy') +
        '</div>' +
        changeList(true) +
        err('changes') +
        foot('Continue') + helpBar();
    }

    function changeLine(c) {
      var sp = c.type === 'add' ? null : storeProduct(c.pid);
      var img = c.type === 'add' ? c.img : (c.type === 'swap' && c.to ? c.to.img : (c.img || (sp && sp.img)));
      var title, sub;
      if (c.type === 'add') { title = c.title; sub = 'Add to your store'; }
      else if (c.type === 'artwork') { title = c.title; ensureLocs(c); sub = 'New artwork' + (c.locs.length > 1 ? ', ' + c.locs.length + ' locations' : (logoById(c.locs[0].logoId) ? ', ' + logoName(c.locs[0].logoId) : '')); }
      else { title = c.title; sub = c.to ? 'Swap for ' + c.to.title : 'Swap, replacement not chosen yet'; }
      return '<li class="mlsu-cl__it mlsu-cl__it--' + c.type + '">' +
        thumb(img, 'mlsu-cl__th') +
        '<span class="mlsu-cl__t"><b>' + esc(title) + '</b><em>' + esc(sub) + '</em></span>' +
        '<span class="mlsu-tag mlsu-tag--' + c.type + '">' + TYPE_LABEL[c.type] + '</span>' +
        (c.type !== 'add' ? '<button type="button" class="mlsu-linkbtn" data-act="edit-rev" data-pid="' + esc(c.pid) + '">Edit</button>' : '<button type="button" class="mlsu-linkbtn" data-act="edit-add" data-id="' + esc(c.id) + '">Edit</button>') +
        '<button type="button" class="mlsr-picks__x" data-act="rm-change" data-id="' + esc(c.id) + '" aria-label="Remove">' + I.x + '</button>' +
      '</li>';
    }
    function changeList(withHead) {
      var cs = state.data.changes;
      if (!cs.length) {
        return withHead ? '<div class="mlsu-cl mlsu-cl--empty"><p>Your change list is empty. Start with one of the options above.</p></div>' : '';
      }
      return '<div class="mlsu-cl">' +
        (withHead ? '<div class="mlsu-cl__head"><b>Your change list</b><span>' + cs.length + (cs.length === 1 ? ' change' : ' changes') + '</span></div>' : '') +
        '<ul class="mlsu-cl__list">' + cs.map(changeLine).join('') + '</ul></div>';
    }

    /* ---- step 2: add -------------------------------------------------------------------- */

    function crumb(label) {
      return '<button type="button" class="mlsu-crumb" data-act="view" data-view="hub">' + I.chevL + ' ' + esc(label || 'All changes') + '</button>';
    }
    function viewAdd() {
      var s = state.data.store || { title: 'your store' };
      return crumb() +
        '<div class="mlsr-p__head">' +
          '<h2>Add products to ' + esc(s.title) + '</h2>' +
          '<p class="mlsr__sub mlsr__sub--sm">Search for something specific, start from a pack, or filter the full catalog. Tap Add and you choose colors, print locations and artwork for it.</p>' +
        '</div>' +
        '<div data-mlsu-cathost></div>' +
        '<div class="mlsr-pickbar mlsu-bar" data-mlsu-bar></div>' + helpBar();
    }

    /* ---- step 2: revise -------------------------------------------------------------------- */

    function viewRevise() {
      var s = state.data.store || { title: 'your store' };
      var body;
      if (state.productsState === 'loading' || state.productsState === 'idle') {
        body = '<div class="mlsr-state"><span class="mlsr-spin"></span><p>Loading the products in your store…</p></div>';
      } else if (state.productsState === 'error') {
        body = '<div class="mlsr-state"><h3>We could not load your store</h3><p>Check your connection and try again.</p>' +
          '<button type="button" class="mlsr-btn mlsr-btn--outline" data-act="store-retry">Try again</button></div>';
      } else if (!state.products.length) {
        body = '<div class="mlsr-state"><h3>No live products found</h3><p>We could not find anything live in ' + esc(s.title) +
          '. Chat with us and we will sort it out, or add new products instead.</p></div>';
      } else {
        body = '<div class="mlsr-q mlsu-rq">' +
            '<span class="mlsr-q__ico">' + I.search + '</span>' +
            '<input class="mlsr-q__in" type="search" placeholder="Search the ' + state.products.length + ' products in your store" ' +
              'data-mlsu-reviseq value="' + esc(state.reviseQ) + '" autocomplete="off">' +
          '</div>' +
          '<div class="mlsu-grid" data-mlsu-grid>' + reviseCards() + '</div>';
      }
      return crumb() +
        '<div class="mlsr-p__head">' +
          '<h2>Revise a product in ' + esc(s.title) + '</h2>' +
          '<p class="mlsr__sub mlsr__sub--sm">Choose the product to change. You can put new artwork on it, or swap it for a different product from our catalog.</p>' +
        '</div>' +
        body +
        '<div class="mlsr-pickbar mlsu-bar" data-mlsu-bar></div>' + helpBar();
    }
    function reviseCards() {
      var q = norm(state.reviseQ);
      var list = (state.products || []).filter(function (p) {
        return !q || norm(p.title + ' ' + p.type).indexOf(q) !== -1;
      });
      if (!list.length) return '<p class="mlsu-grid__none">Nothing in your store matches “' + esc(state.reviseQ) + '”.</p>';
      return list.map(function (p) {
        var c = changeFor(p.id);
        var badge = c ? '<span class="mlsu-tag mlsu-tag--' + c.type + ' mlsu-card__tag">' + TYPE_LABEL[c.type] + '</span>' : '';
        return '<button type="button" class="mlsu-card' + (c ? ' is-on' : '') + '" data-act="open-rev" data-pid="' + esc(p.id) + '">' +
          '<span class="mlsu-card__img">' + thumb(p.img, 'mlsu-card__im') + badge + '</span>' +
          '<span class="mlsu-card__t">' + esc(p.title) + '</span>' +
          '<span class="mlsu-card__p">' + money(p.price) + '</span>' +
          '<span class="mlsu-card__cta">' + (c ? 'Edit change' : 'Revise this') + '</span>' +
        '</button>';
      }).join('');
    }

    /* ---- step 2: swap ------------------------------------------------------------------------ */

    function viewSwap() {
      var d = state.draft || {};
      var sp = storeProduct(d.pid) || {};
      return '<button type="button" class="mlsu-crumb" data-act="swap-cancel">' + I.chevL + ' Back to ' + esc(sp.title || 'the product') + '</button>' +
        '<div class="mlsu-swaphead">' +
          thumb(sp.img, 'mlsu-swaphead__th') +
          '<span class="mlsu-swaphead__arrow">' + I.arrow + '</span>' +
          '<span class="mlsu-swaphead__t"><h2>Pick a replacement for ' + esc(sp.title || 'this product') + '</h2>' +
          '<p class="mlsr__sub mlsr__sub--sm">Tap Add on the product you want instead. The current one comes down to draft while we build its replacement.</p></span>' +
        '</div>' +
        '<div data-mlsu-cathost></div>' + helpBar();
    }

    /* ---- the bottom bar for add and revise --------------------------------------------------- */

    function paintBar() {
      var bar = root.querySelector('[data-mlsu-bar]');
      if (!bar) return;
      var n, label;
      if (state.view === 'add') {
        n = changes('add').length;
        label = n ? '<b>' + n + (n === 1 ? ' product' : ' products') + '</b> to add' : 'Nothing picked yet';
      } else {
        n = changes('artwork').length + changes('swap').length;
        label = n ? '<b>' + n + (n === 1 ? ' product' : ' products') + '</b> to revise' : 'Pick a product to revise';
      }
      var total = state.data.changes.length;
      bar.innerHTML =
        (state.capNote ? '<p class="mlsr-capnote mlsr-capnote--bar">' + I.info + '<span>' + esc(state.capNote) + '</span></p>' : '') +
        '<div class="mlsr-pickbar__in">' +
          '<div class="mlsr-pickbar__l">' +
            '<button type="button" class="mlsr-btn mlsr-btn--outline mlsu-bar__back" data-act="view" data-view="hub">' + I.chevL + ' Back</button>' +
            '<span class="mlsr-pickbar__n">' + label +
            (total > n ? ' <em class="mlsu-bar__all">' + total + ' changes in all</em>' : '') + '</span></div>' +
          '<div class="mlsr-pickbar__r">' +
            '<button type="button" class="mlsr-btn mlsr-btn--primary" data-act="view" data-view="hub">Done ' + I.chevR + '</button>' +
          '</div>' +
        '</div>';
      bar.classList.toggle('has-picks', n > 0);
    }

    /* ---- the revise panel ---------------------------------------------------------------------- */

    function openRevise(pid) {
      var sp = storeProduct(pid);
      if (!sp) return;
      var c = changeFor(pid);
      state.draft = c ? JSON.parse(JSON.stringify(c)) : {
        id: uid(), type: '', pid: sp.id, ph: sp.h, title: sp.title, img: sp.img, url: sp.url,
        to: null, colors: [], placement: '', logoId: '', notes: '',
        locs: [{ placement: '', logoId: '' }]
      };
      ensureLocs(state.draft);
      state.modal = pid;
      lookupCatalog(sp);
      delete state.errors.draftType; delete state.errors.draftLogo; delete state.errors.draftTo;
      renderModal();
    }
    function closeModal() {
      state.zoom = null; renderZoom();
      state.modal = null;
      state.draft = null;
      renderModal();
      // Opened from the Details step to fix one revision: go back there rather
      // than stranding the customer in the product grid.
      if (state.returnTo) {
        var to = state.returnTo;
        state.returnTo = 0;
        goTo(to);
      }
    }
    function modalHost() {
      var m = document.querySelector('[data-mlsu-modal]');
      if (m) return m;
      m = document.createElement('div');
      m.className = 'mlsu-modal mlsr';
      m.setAttribute('data-mlsu-modal', '');
      m.setAttribute('role', 'dialog');
      m.setAttribute('aria-modal', 'true');
      document.body.appendChild(m);
      m.addEventListener('click', onClick);
      m.addEventListener('input', onInput);
      m.addEventListener('change', onChange);
      bindDrops(m);
      return m;
    }
    function logoTile(l, ctx, on) {
      var i = logoIndex(l.id);
      return '<span class="mlsu-lwrap"><button type="button" class="mlsu-lopt' + (on ? ' is-on' : '') + '" data-act="pick-logo" data-ctx="' + ctx + '" data-logo="' + l.id + '">' +
        (l.previewUrl ? '<img class="mlsu-lopt__img" src="' + esc(l.previewUrl) + '" alt="">' :
          '<span class="mlsu-lopt__img mlsu-lopt__img--ext">' + esc((l.name.split('.').pop() || '').toUpperCase()) + '</span>') +
        '<span>Logo ' + (i + 1) + '<em>' + esc(l.name) + '</em></span></button>' +
        '<button type="button" class="mlsu-lopt__x" data-act="logo-rm" data-logo="' + l.id + '" aria-label="Remove ' + esc(l.name) + '" title="Remove this file, then upload a different one">' + I.x + '</button></span>';
    }
    // A larger tile for a file uploaded earlier, so the artwork is easy to recognize.
    function reuseTile(l, ctx) {
      var i = logoIndex(l.id);
      return '<span class="mlsu-rt"><button type="button" class="mlsu-rt__b" data-act="pick-logo" data-ctx="' + ctx + '" data-logo="' + l.id + '">' +
        (l.previewUrl ? '<img class="mlsu-rt__img" src="' + esc(l.previewUrl) + '" alt="">' :
          '<span class="mlsu-rt__img mlsu-rt__img--ext">' + esc((l.name.split('.').pop() || '').slice(0, 4).toUpperCase()) + '</span>') +
        '<span class="mlsu-rt__n">Logo ' + (i + 1) + '<em>' + esc(l.name) + '</em></span></button>' +
        '<button type="button" class="mlsu-lopt__x" data-act="logo-rm" data-logo="' + l.id + '" aria-label="Remove ' + esc(l.name) + '" title="Remove this file">' + I.x + '</button></span>';
    }
    // A location shows its own file, and nothing else until the customer asks.
    // Files uploaded for other products sit behind "use a file you already
    // uploaded", so a fresh product never looks like it has artwork on it.
    function logoPicker(selected, ctx, errKey, allowNone, noneLabel) {
      var cur = selected ? logoById(selected) : null;
      var others = state.logos.filter(function (l) { return l !== cur; });
      var opts = '';
      if (allowNone) {
        opts += '<button type="button" class="mlsu-lopt' + (!cur ? ' is-on' : '') + '" data-act="pick-logo" data-ctx="' + ctx + '" data-logo="">' +
          '<span class="mlsu-lopt__img mlsu-lopt__img--store">' + I.store + '</span><span>' + esc(noneLabel || 'Use the artwork already in my store') + '</span></button>';
      }
      if (cur) opts += logoTile(cur, ctx, true);
      var canAdd = state.logos.length < MAX_LOGOS;
      var upLabel = cur ? 'Upload a different file' : 'Upload artwork';
      var reuse = others.length
        ? '<div class="mlsu-reuse"><p class="mlsr-label mlsu-reuse__t">Choose previously uploaded art</p><div class="mlsu-reuse__grid">' +
            others.map(function (l) { return reuseTile(l, ctx); }).join('') + '</div></div>'
        : '';
      return '<div class="mlsu-lopts' + (errKey && state.errors[errKey] ? ' is-invalid' : '') + '">' + opts +
        (canAdd ? '<label class="mlsr-drop mlsr-drop--sm mlsu-ldrop">' +
          '<input type="file" data-mlsu-file="' + ctx + '" accept="' + ACCEPT_ATTR + '" hidden>' +
          I.up + '<span><b>' + upLabel + '</b><em>AI, EPS, SVG, PDF, PNG or JPG, ' + MAX_LOGO_MB + ' MB max</em></span></label>' : '') +
        '</div>' + reuse +
        '<p class="mlsr-err" data-mlsu-fileerr="' + ctx + '" hidden></p>' +
        (errKey ? err(errKey) : '');
    }
    /* One block per location: where it goes, and the artwork for it. ctx is
       'draft' inside the revise panel and 'c<index>' on the Details step. */
    function locEditor(c, ctx, spots, o) {
      o = o || {};
      ensureLocs(c);
      var locs = c.locs, multi = locs.length > 1;
      var html = locs.map(function (l, j) {
        var others = locs.filter(function (x, k) { return k !== j && x.placement; }).map(function (x) { return x.placement; });
        var list = spots.filter(function (sp) { return others.indexOf(sp) === -1; });
        var keep = 'Choose a location';
        var needLogo = c.type !== 'swap' || j > 0;
        return '<div class="mlsu-loc' + (state.errors[o.pe + j] || state.errors[o.le + j] ? ' is-invalid' : '') + '">' +
          '<div class="mlsu-loc__head"><b>' + (multi ? 'Location ' + (j + 1) : 'Location') + '</b>' +
            (j > 0 ? '<button type="button" class="mlsu-linkbtn mlsu-linkbtn--danger" data-act="loc-rm" data-ctx="' + ctx + '" data-j="' + j + '">Remove</button>' : '') +
          '</div>' +
          '<div class="mlsr-field"><label class="mlsr-label">Where should it go?</label>' +
            placementSelect(l.placement, list, 'data-lbind="placement" data-ctx="' + ctx + '" data-j="' + j + '"', keep) +
            err(o.pe + j) + (j === 0 && o.note ? o.note : '') + '</div>' +
          '<div class="mlsr-field"><p class="mlsr-label">Artwork' + (needLogo ? '<span class="req">*</span>' : '') + '</p>' +
            logoPicker(l.logoId, ctx + ':' + j, o.le + j, !needLogo, o.noneLabel) + '</div>' +
        '</div>';
      }).join('');
      var max = Math.min(MAX_LOCS, Math.max(spots.length, 1));
      var more = locs.length < max
        ? '<button type="button" class="mlsr-btn mlsr-btn--outline mlsu-locadd" data-act="loc-add" data-ctx="' + ctx + '">' + I.plus + ' Add another location</button>'
        : '';
      return '<div class="mlsu-locs">' + html + more + '</div>';
    }
    function placementSelect(val, list, bind, keepLabel) {
      var opts = (keepLabel ? ['<option value=""' + (!val ? ' selected' : '') + '>' + esc(keepLabel) + '</option>'] : [])
        .concat(list.map(function (p) { return '<option' + (p === val ? ' selected' : '') + '>' + esc(p) + '</option>'; }));
      if (val && list.indexOf(val) === -1) opts.push('<option selected>' + esc(val) + '</option>');
      return '<select class="mlsr-select" ' + bind + '>' + opts.join('') + '</select>';
    }

    // Color tiles with photos and a larger view, shared by adding a product and
    // swapping to a different one.
    function colorField(d) {
      var ct = colorTarget(d), av = ct.avail;
      if (!av.length) return '';
      loadColorImgs(ct.h);
      return '<div class="mlsr-field"><p class="mlsr-label">Colors <span class="opt">(up to ' + MAX_COLORS + ')</span></p>' +
        '<div class="mlsu-cws">' + av.map(function (col) {
          var on = (d.colors || []).indexOf(col) !== -1, ph = colorPhoto(ct.h, col);
          if (!ph) {
            return '<button type="button" class="mlsr-colorchip' + (on ? ' is-on' : '') + '" data-act="dcolor" data-color="' + esc(col) + '" aria-pressed="' + on + '">' + esc(col) + '</button>';
          }
          return '<span class="mlsu-cw' + (on ? ' is-on' : '') + '">' +
            '<button type="button" class="mlsu-cw__o" data-act="dcolor" data-color="' + esc(col) + '" aria-pressed="' + on + '">' +
              '<span class="mlsu-cw__img"><img src="' + esc(sized(ph, 200)) + '" alt="" loading="lazy">' + (on ? '<span class="mlsu-cw__tick">' + I.check + '</span>' : '') + '</span>' +
              '<span class="mlsu-cw__n">' + esc(col) + '</span></button>' +
            '<button type="button" class="mlsu-cw__z" data-act="czoom" data-color="' + esc(col) + '" aria-label="See ' + esc(col) + ' larger" title="See larger">' + I.zoom + '</button>' +
          '</span>';
        }).join('') + '</div></div>';
    }

    function renderModal() {
      if (!state.modal || !state.draft) {
        var m0 = document.querySelector('[data-mlsu-modal]');
        if (m0) { m0.classList.remove('is-open'); m0.innerHTML = ''; }
        if (!document.querySelector('[data-mlsr-qvmodal].is-open')) document.body.style.overflow = '';
        return;
      }
      var d = state.draft, sp = storeProduct(d.pid) || d;
      var m = modalHost();
      var existing = d.type === 'add' ? (state.data.changes.filter(function (c) { return c.id === d.id; })[0] || null) : changeFor(d.pid);

      var choice = d.type === 'add' ? '' :
        '<p class="mlsr-label">What do you want to change?</p>' +
        '<div class="mlsu-choice' + (state.errors.draftType ? ' is-invalid' : '') + '">' +
          '<button type="button" class="mlsu-choice__o' + (d.type === 'artwork' ? ' is-on' : '') + '" data-act="draft-type" data-type="artwork">' +
            '<span class="mlsu-choice__ico">' + I.brush + '</span><b>Change the artwork</b><em>Same product, new or updated logo.</em></button>' +
          '<button type="button" class="mlsu-choice__o' + (d.type === 'swap' ? ' is-on' : '') + '" data-act="draft-type" data-type="swap">' +
            '<span class="mlsu-choice__ico">' + I.swap + '</span><b>Change the product</b><em>Replace it with a different product from our catalog.</em></button>' +
        '</div>' + err('draftType');

      var detail = '';
      if (d.type === 'add') {
        detail = colorField(d) +
          '<p class="mlsr-label">Artwork and where it goes</p>' +
          locEditor(d, 'draft', placementsFor(d), { pe: 'draftPlace_', le: 'draftLogo_' });
      } else if (d.type === 'artwork') {
        detail = '<p class="mlsr-label">New artwork and where it goes</p>' +
          locEditor(d, 'draft', spotsForStore(d.pid), {
            note: spotsNote(d.pid), pe: 'draftPlace_', le: 'draftLogo_'
          });
      } else if (d.type === 'swap') {
        detail =
          '<div class="mlsr-field"><p class="mlsr-label">Replacement product<span class="req">*</span></p>' +
            (d.to
              ? '<div class="mlsu-swapto">' + thumb(sp.img, 'mlsu-swapto__th') + '<span class="mlsu-swapto__arrow">' + I.arrow + '</span>' +
                  thumb(d.to.img, 'mlsu-swapto__th') +
                  '<span class="mlsu-swapto__t"><b>' + esc(d.to.title) + '</b><em>' + esc([d.to.brand, d.to.cat].filter(Boolean).join(' · ')) + '</em></span>' +
                  '<button type="button" class="mlsu-linkbtn" data-act="swap-pick">Choose a different one</button></div>'
              : '<button type="button" class="mlsr-btn mlsr-btn--teal" data-act="swap-pick">' + I.search + ' Choose from the catalog</button>') +
            err('draftTo') + '</div>' +
          (d.to ? colorField(d) : '') +
          '<div class="mlsr-field"><p class="mlsr-label">Artwork on the new product</p>' +
            logoPicker(d.locs[0].logoId, 'draft:0', '', true, 'Same artwork as the current product') + '</div>';
      }

      var oldP = m.querySelector('.mlsu-modal__panel'), oldB = m.querySelector('.mlsu-modal__body');
      var keepP = oldP ? oldP.scrollTop : 0, keepB = oldB ? oldB.scrollTop : 0;
      m.innerHTML =
        '<div class="mlsu-modal__scrim" data-act="modal-close"></div>' +
        '<div class="mlsu-modal__panel">' +
          '<button type="button" class="mlsr-qv__x mlsu-modal__x" data-act="modal-close" aria-label="Close">' + I.x + '</button>' +
          '<div class="mlsu-modal__prod">' + thumb(sp.img, 'mlsu-modal__th') +
            '<span><p class="mlsr-qv__eyebrow">' + (d.type === 'add' ? 'New product for your store' : 'Live in your store') + '</p><h3>' + esc(sp.title) + '</h3>' +
            (sp.price ? '<p class="mlsu-modal__price">' + money(sp.price) + '</p>' : '') + '</span></div>' +
          '<div class="mlsu-modal__body">' + choice + detail +
            ((d.type === 'artwork' || d.type === 'swap') ? '<p class="mlsu-modal__fine">' + I.info + '<span>When we start, this product is moved to draft so it disappears from your store, and the new version goes live once it is built.</span></p>' : '') +
          '</div>' +
          '<div class="mlsu-modal__foot">' +
            (existing ? '<button type="button" class="mlsu-linkbtn mlsu-linkbtn--danger" data-act="draft-remove">Remove this change</button>' : '<span></span>') +
            '<span class="mlsu-modal__btns">' +
              '<button type="button" class="mlsr-btn mlsr-btn--outline" data-act="modal-close">Cancel</button>' +
              '<button type="button" class="mlsr-btn mlsr-btn--primary" data-act="draft-save">' + (existing ? 'Save change' : 'Add to my list') + '</button>' +
            '</span>' +
          '</div>' +
        '</div>';
      m.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var nP = m.querySelector('.mlsu-modal__panel'), nB = m.querySelector('.mlsu-modal__body');
      if (nP && keepP) nP.scrollTop = keepP;
      if (nB && keepB) nB.scrollTop = keepB;
    }

    function saveDraftChange() {
      var d = state.draft;
      if (!d) return;
      grabModal();
      var e = {};
      if (!d.type) e.draftType = 'Choose what you want to change.';
      if (d.type === 'artwork' || d.type === 'add') locErrors(d, e, 'draftLogo_', 'draftPlace_');
      if (d.type === 'swap' && !d.to) e.draftTo = 'Choose the product to replace it with.';
      Object.keys(state.errors).forEach(function (k) { if (/^draft/.test(k)) delete state.errors[k]; });
      if (Object.keys(e).length) { Object.keys(e).forEach(function (k) { state.errors[k] = e[k]; }); renderModal(); return; }
      if (d.type === 'artwork') { d.to = null; d.colors = []; }
      syncFirst(d);
      var i = -1;
      state.data.changes.forEach(function (c, k) { if (c.id === d.id || (c.type !== 'add' && String(c.pid) === String(d.pid))) i = k; });
      if (i > -1) state.data.changes[i] = d;
      else {
        if (state.data.changes.length >= MAX_CHANGES) { state.capNote = 'One request can carry up to ' + MAX_CHANGES + ' changes.'; closeModal(); paintBar(); return; }
        state.data.changes.push(d);
      }
      delete state.errors.changes;
      saveDraft();
      closeModal();
      if (state.step === 2 && state.view === 'revise') {
        var g = root.querySelector('[data-mlsu-grid]');
        if (g) g.innerHTML = reviseCards();
        paintBar();
      } else { render(); notifyPicker(); }
    }

    /* ---- step 3: details ----------------------------------------------------------------------- */

    function cardIssues(c) {
      var e = {};
      if (c.type === 'swap' && !c.to) e.to = 1;
      else locErrors(c, e, 'l', 'p');
      return e;
    }
    function step3() {
      var cs = state.data.changes, ready = 0;
      var cards = cs.map(function (c) {
        ensureLocs(c);
        var sp = c.type === 'add' ? null : (storeProduct(c.pid) || c);
        var img = c.type === 'swap' && c.to ? c.to.img : (c.type === 'add' ? c.img : ((sp && sp.img) || c.img));
        var title = c.type === 'swap' && c.to ? c.to.title : c.title;
        var sub = c.type === 'add' ? [c.brand, c.cat].filter(Boolean).join(' · ')
          : (c.type === 'artwork' ? 'Currently in your store' : 'Replaces ' + c.title);
        var ok = !Object.keys(cardIssues(c)).length;
        if (ok) ready++;
        var shown = [];
        Object.keys(state.errors).forEach(function (k) {
          if (k === 'to_' + c.id || k.indexOf('logo_' + c.id + '_') === 0 || k.indexOf('place_' + c.id + '_') === 0) shown.push(state.errors[k]);
        });
        var target = c.type === 'add' ? c : (c.type === 'swap' ? c.to : null);
        var rows;
        if (c.type === 'swap' && !c.to) rows = '<li class="mlsu-dcard__loc is-need"><span><b>Replacement not chosen yet</b></span></li>';
        else rows = c.locs.map(function (l, j) {
          var lg = l.logoId ? logoById(l.logoId) : null;
          var tn = lg
            ? (lg.previewUrl ? '<img class="mlsu-dcard__logo" src="' + esc(lg.previewUrl) + '" alt="">'
                : '<span class="mlsu-dcard__logo mlsu-dcard__logo--ext">' + esc((lg.name.split('.').pop() || '').toUpperCase()) + '</span>')
            : '<span class="mlsu-dcard__logo mlsu-dcard__logo--none"></span>';
          var art = lg ? 'Logo ' + (logoIndex(l.logoId) + 1) + ', ' + lg.name
            : (l.logoId ? 'File missing, upload it again'
              : (c.type === 'swap' && j === 0 ? 'Same artwork as now' : 'No artwork yet'));
          var need = !l.placement || (!lg && !(c.type === 'swap' && j === 0));
          return '<li class="mlsu-dcard__loc' + (need ? ' is-need' : '') + '">' + tn +
            '<span><b>' + esc(l.placement || 'Location not chosen') + '</b><em>' + esc(art) + '</em></span></li>';
        }).join('');
        var colors = target && c.colors && c.colors.length
          ? '<p class="mlsu-dcard__colors"><span>Colors</span>' + esc(c.colors.join(', ')) + '</p>' : '';
        var notes = c.notes ? '<p class="mlsu-dcard__notes">“' + esc(c.notes) + '”</p>' : '';
        return '<li class="mlsu-dcard' + (shown.length ? ' is-invalid' : '') + (ok ? ' is-ok' : '') + '">' +
          '<div class="mlsu-dcard__top">' + thumb(img, 'mlsu-dcard__im') +
            '<span class="mlsu-dcard__t"><span class="mlsu-tag mlsu-tag--' + c.type + '">' + TYPE_LABEL[c.type] + '</span><b>' + esc(title) + '</b>' +
            (sub ? '<em>' + esc(sub) + '</em>' : '') + '</span>' +
            '<button type="button" class="mlsr-picks__x" data-act="rm-change" data-id="' + esc(c.id) + '" aria-label="Remove">' + I.x + '</button></div>' +
          colors +
          '<ul class="mlsu-dcard__locs">' + rows + '</ul>' + notes +
          (shown.length ? '<p class="mlsr-err">' + esc(shown.filter(function (v, i) { return shown.indexOf(v) === i; }).join(' ')) + '</p>' : '') +
          '<div class="mlsu-dcard__foot"><span class="mlsu-st ' + (ok ? 'mlsu-st--ok' : 'mlsu-st--need') + '">' +
            (ok ? I.check + ' Ready' : 'Needs your attention') + '</span>' +
            '<button type="button" class="mlsr-btn mlsr-btn--outline mlsu-dcard__edit" data-act="' + (c.type === 'add' ? 'edit-add' : 'edit-rev') + '" data-id="' + esc(c.id) + '" data-pid="' + esc(c.pid || '') + '">' +
              (ok ? 'Edit' : 'Finish this one') + '</button></div>' +
        '</li>';
      }).join('');

      return '<div class="mlsr__head mlsu-head"><h2>Check each change</h2>' +
          '<p class="mlsr__sub">' + (cs.length ? '<b>' + ready + ' of ' + cs.length + '</b> ready. ' : '') +
          'Tap Edit on any card to change its colors, print locations or artwork.</p></div>' +
        (cs.length ? '<ol class="mlsu-dgrid">' + cards + '</ol>' : '<div class="mlsu-cl mlsu-cl--empty"><p>No changes yet. Go back and add some.</p></div>') +
        '<div class="mlsr-field mlsu-gnotes"><label class="mlsr-label" for="mlsu-notes">Anything else about this request? <span class="opt">(Optional)</span></label>' +
          '<textarea class="mlsr-textarea" id="mlsu-notes" rows="3" data-bind="notes" placeholder="Deadlines, an event this is for, anything we should know">' + esc(state.data.notes) + '</textarea></div>' +
        foot('Review') + helpBar();
    }

    /* ---- step 4: review -------------------------------------------------------------------------- */

    function step4() {
      var d = state.data;
      function group(type, title, note) {
        var cs = changes(type);
        if (!cs.length) return '';
        return '<div class="mlsu-rgroup"><h3>' + title + ' <span>' + cs.length + '</span></h3>' +
          (note ? '<p class="mlsu-rgroup__note">' + note + '</p>' : '') +
          '<ul class="mlsu-rlist">' + cs.map(function (c) {
            var bits = [];
            if (c.type === 'swap') bits.push('Replaces ' + c.title);
            if (c.colors && c.colors.length) bits.push(c.colors.join(', '));
            ensureLocs(c);
            c.locs.forEach(function (l, j) {
              var art = l.logoId && logoById(l.logoId) ? logoName(l.logoId) : (c.type === 'swap' ? 'same artwork as now' : 'store\'s current artwork');
              bits.push((c.locs.length > 1 ? 'Location ' + (j + 1) + ': ' : '') + (l.placement || (c.type === 'artwork' ? 'Same place as now' : 'Standard')) + ', ' + art);
            });
            if (c.notes) bits.push('“' + c.notes + '”');
            var img = c.type === 'swap' && c.to ? c.to.img : c.img;
            return '<li>' + thumb(img, 'mlsu-rlist__th') + '<span><b>' + esc(c.type === 'swap' && c.to ? c.to.title : c.title) + '</b><em>' +
              esc(bits.join(' · ')) + '</em></span></li>';
          }).join('') + '</ul></div>';
      }
      return '<div class="mlsr__head mlsu-head"><h2>Check it over and send</h2>' +
          '<p class="mlsr__sub">This goes straight to our team. You can still go back and change anything.</p></div>' +
        '<div class="mlsu-review">' +
          '<div class="mlsu-review__main">' +
            group('add', 'New products', 'Added to your store alongside what is already there.') +
            group('artwork', 'New artwork', 'Each of these comes down to draft while we rebuild it with the new artwork.') +
            group('swap', 'Product swaps', 'Each current product comes down to draft and the replacement goes up in its place.') +
            (d.notes ? '<div class="mlsu-rgroup"><h3>Notes</h3><p class="mlsu-rgroup__note">' + esc(d.notes) + '</p></div>' : '') +
          '</div>' +
          '<aside class="mlsu-review__side">' +
            '<div class="mlsu-rbox"><p class="mlsu-rbox__t">Store</p><b>' + esc(d.store ? d.store.title : '') + '</b></div>' +
            '<div class="mlsu-rbox"><p class="mlsu-rbox__t">Contact</p><b>' + esc(d.firstName + ' ' + d.lastName) + '</b>' +
              '<span>' + esc(d.email) + '</span><span>' + esc(d.phone) + '</span></div>' +
            (state.logos.length ? '<div class="mlsu-rbox"><p class="mlsu-rbox__t">Artwork</p>' + state.logos.map(function (l, i) {
              return '<span>Logo ' + (i + 1) + ': ' + esc(l.name) + '</span>';
            }).join('') + '</div>' : '') +
            '<button type="button" class="mlsu-linkbtn" data-act="goto" data-step="1">Edit details</button>' +
          '</aside>' +
        '</div>' +
        '<p class="mlsr-submit-err" data-mlsu-submiterr></p>' +
        '<div class="mlsr__foot">' +
          '<button type="button" class="mlsr-btn mlsr-btn--outline" data-act="back"' + (state.submitting ? ' disabled' : '') + '>' + I.chevL + ' Back</button>' +
          '<button type="button" class="mlsr-btn mlsr-btn--primary" data-act="submit"' + (state.submitting ? ' disabled' : '') + '>' +
            (state.submitting ? '<span class="mlsr-spin"></span> Sending…' : 'Send my request ' + I.chevR) + '</button>' +
        '</div>' + helpBar();
    }

    /* -- inputs ------------------------------------------------------------------------------- */

    function grabInputs() {
      root.querySelectorAll('[data-bind]').forEach(function (el) { state.data[el.getAttribute('data-bind')] = el.value; });
      root.querySelectorAll('[data-cbind]').forEach(function (el) {
        var c = state.data.changes[+el.getAttribute('data-i')];
        if (c) c[el.getAttribute('data-cbind')] = el.value;
      });
    }
    function grabModal() {
      var m = document.querySelector('[data-mlsu-modal]');
      if (!m || !state.draft) return;
      m.querySelectorAll('[data-dbind]').forEach(function (el) { state.draft[el.getAttribute('data-dbind')] = el.value; });
    }

    function addFiles(files, ctx) {
      var errEl = document.querySelector('[data-mlsu-fileerr="' + ctx + '"]');
      var added = null, problem = '';
      Array.prototype.slice.call(files || []).forEach(function (file) {
        if (state.logos.length >= MAX_LOGOS) { problem = 'You can attach up to ' + MAX_LOGOS + ' artwork files.'; return; }
        if (file.size > MAX_LOGO_MB * 1024 * 1024) { problem = file.name + ' is over ' + MAX_LOGO_MB + ' MB. Email it to us instead.'; return; }
        if (!ACCEPT_EXT.test(file.name) && !/^image\//.test(file.type)) { problem = file.name + ' is not a file type we can use.'; return; }
        var l = { id: 'l' + Date.now().toString(36) + (++logoSeq), file: file, name: file.name, previewUrl: '' };
        if (/^image\/(png|jpe?g|gif|webp|svg\+xml)$/.test(file.type)) {
          try { l.previewUrl = URL.createObjectURL(file); } catch (e) {}
        }
        state.logos.push(l);
        fileSave(l);
        added = l;
      });
      if (added) {
        var tg = locTarget(ctx);
        if (tg && tg.loc) {
          var prevId = tg.loc.logoId;
          tg.loc.logoId = added.id;
          if (prevId && prevId !== added.id && !logoInUse(prevId)) dropLogo(prevId);
          delete state.errors[(tg.draft ? 'draftLogo_' : 'logo_' + tg.c.id + '_') + tg.j];
        }
        saveDraft();
        if (tg && tg.draft) renderModal(); else { grabInputs(); render(); }
      }
      if (problem) {
        var el = document.querySelector('[data-mlsu-fileerr="' + ctx + '"]') || errEl;
        if (el) { el.textContent = problem; el.hidden = false; }
      }
    }

    /* -- events ---------------------------------------------------------------------------------- */

    function onClick(ev) {
      var t = ev.target.closest('[data-act]');
      if (!t) return;
      var act = t.getAttribute('data-act');
      if (act === 'start') { state.started = true; state.step = 1; saveDraft(); render(); scrollTop(); return; }
      if (act === 'next') return next();
      if (act === 'back') { grabInputs(); return back(); }
      if (act === 'goto') { grabInputs(); return goTo(+t.getAttribute('data-step')); }
      if (act === 'chat') return openChat();
      if (act === 'store-pick') {
        var box = root.querySelector('[data-mlsu-sugg]');
        var s = box && box.__hits && box.__hits[+t.getAttribute('data-i')];
        if (s) pickStore(s);
        return;
      }
      if (act === 'store-clear') {
        state.data.store = null; state.products = null; state.productsState = 'idle'; loadSeq++;
        saveDraft(); paintStoreCard();
        var inp = root.querySelector('[data-mlsu-storeq]');
        if (inp) { inp.value = ''; inp.focus(); }
        return;
      }
      if (act === 'store-retry') return loadStoreProducts();
      if (act === 'view') {
        var v = t.getAttribute('data-view');
        if (v === 'revise' && state.productsState === 'idle') loadStoreProducts();
        state.capNote = '';
        return setView(v);
      }
      if (act === 'rm-change') {
        var id = t.getAttribute('data-id');
        grabInputs();
        state.data.changes = state.data.changes.filter(function (c) { return c.id !== id; });
        saveDraft(); notifyPicker(); render(); return;
      }
      if (act === 'open-rev') return openRevise(t.getAttribute('data-pid'));
      if (act === 'edit-add') {
        grabInputs();
        var eid = t.getAttribute('data-id');
        var ec = state.data.changes.filter(function (c) { return c.id === eid; })[0];
        if (ec) openAdd(null, ec);
        return;
      }
      if (act === 'dcolor') {
        grabModal();
        var dd = state.draft, dcol = t.getAttribute('data-color');
        if (!dd) return;
        dd.colors = dd.colors || [];
        var dk = dd.colors.indexOf(dcol);
        if (dk > -1) { if (dd.colors.length > 1) dd.colors.splice(dk, 1); }
        else if (dd.colors.length < MAX_COLORS) dd.colors.push(dcol);
        renderModal();
        if (state.zoom) renderZoom();
        return;
      }
      if (act === 'czoom') { grabModal(); state.zoom = { color: t.getAttribute('data-color') }; renderZoom(); return; }
      if (act === 'zoom-close') return closeZoom();
      if (act === 'zoom-step') {
        var zl = zoomList(), zi = zl.indexOf(state.zoom && state.zoom.color);
        if (zi < 0 || zl.length < 2) return;
        state.zoom = { color: zl[(zi + (+t.getAttribute('data-d')) + zl.length) % zl.length] };
        renderZoom();
        return;
      }
      if (act === 'edit-rev') {
        grabInputs();
        var pid = t.getAttribute('data-pid');
        if (state.step !== 2) { state.returnTo = state.step; state.step = 2; root.setAttribute('data-step', '2'); }
        state.view = 'revise'; render();
        return openRevise(pid);
      }
      if (act === 'modal-close') return closeModal();
      if (act === 'draft-type') {
        grabModal();
        var nt = t.getAttribute('data-type');
        if (state.draft.type !== nt) {
          ensureLocs(state.draft);
          state.draft.locs = [{ placement: '', logoId: state.draft.locs[0].logoId || '' }];
        }
        state.draft.type = nt;
        delete state.errors.draftType;
        renderModal();
        if (state.draft.type === 'swap' && !state.draft.to) openSwapPicker();
        return;
      }
      if (act === 'swap-pick') { grabModal(); return openSwapPicker(); }
      if (act === 'swap-cancel') { state.view = 'revise'; state.modal = state.draft ? state.draft.pid : null; render(); scrollTop(); return; }
      if (act === 'draft-save') return saveDraftChange();
      if (act === 'draft-remove') {
        var dp = state.draft && state.draft.pid, dpid = state.draft && state.draft.id, dadd = !!state.draft && state.draft.type === 'add';
        state.data.changes = state.data.changes.filter(function (c) { return dadd ? c.id !== dpid : (c.type === 'add' || String(c.pid) !== String(dp)); });
        saveDraft(); closeModal();
        var g = root.querySelector('[data-mlsu-grid]');
        if (g) g.innerHTML = reviseCards();
        paintBar();
        if (state.step !== 2 || state.view !== 'revise') render();
        return;
      }
      if (act === 'pick-logo') {
        var ctx = t.getAttribute('data-ctx'), lid = t.getAttribute('data-logo');
        var tg = locTarget(ctx);
        if (!tg || !tg.loc) return;
        if (tg.draft) { grabModal(); tg.loc.logoId = lid; delete state.errors['draftLogo_' + tg.j]; renderModal(); }
        else { grabInputs(); tg.loc.logoId = lid; delete state.errors['logo_' + tg.c.id + '_' + tg.j]; saveDraft(); render(); }
        return;
      }
      if (act === 'logo-rm') {
        var rid = t.getAttribute('data-logo'), ri = logoIndex(rid);
        if (ri > -1) dropLogo(rid);
        var clr = function (c) {
          ensureLocs(c).locs.forEach(function (l) { if (l.logoId === rid) l.logoId = ''; });
          syncFirst(c);
        };
        grabInputs(); grabModal();
        state.data.changes.forEach(clr);
        if (state.draft) clr(state.draft);
        saveDraft(); render();
        return;
      }
      if (act === 'loc-add' || act === 'loc-rm') {
        var lbase = t.getAttribute('data-ctx'), ltg = locTarget(lbase + ':0');
        if (!ltg) return;
        if (ltg.draft) grabModal(); else grabInputs();
        var lc = ltg.c;
        if (act === 'loc-add') {
          if (lc.locs.length >= MAX_LOCS) return;
          lc.locs.push({ placement: '', logoId: '' });
        } else {
          var rj = +t.getAttribute('data-j');
          if (rj > 0) lc.locs.splice(rj, 1);
        }
        Object.keys(state.errors).forEach(function (k) { if (/^(draftLogo_|draftPlace_|logo_|place_)/.test(k)) delete state.errors[k]; });
        syncFirst(lc);
        if (ltg.draft) renderModal(); else { saveDraft(); render(); }
        return;
      }
      if (act === 'color') {
        grabInputs();
        var cc = state.data.changes[+t.getAttribute('data-i')];
        var col = t.getAttribute('data-color');
        if (!cc) return;
        cc.colors = cc.colors || [];
        var k = cc.colors.indexOf(col);
        if (k > -1) { if (cc.colors.length > 1) cc.colors.splice(k, 1); }
        else if (cc.colors.length < MAX_COLORS) cc.colors.push(col);
        saveDraft(); render(); return;
      }
      if (act === 'submit') return submit();
    }

    function openSwapPicker() {
      state.modal = null;
      renderModal();
      state.view = 'swap';
      render();
      scrollTop();
    }

    function onInput(ev) {
      var el = ev.target;
      if (el.matches('[data-mlsu-storeq]')) return onStoreInput(el.value);
      if (el.matches('[data-mlsu-reviseq]')) {
        state.reviseQ = el.value;
        var g = root.querySelector('[data-mlsu-grid]');
        if (g) g.innerHTML = reviseCards();
        return;
      }
      if (el.matches('[data-bind]')) {
        state.data[el.getAttribute('data-bind')] = el.value;
        var k = el.getAttribute('data-bind');
        if (state.errors[k]) {
          delete state.errors[k];
          var f = el.closest('.mlsr-field');
          if (f) { f.classList.remove('is-invalid'); var e = f.querySelector('.mlsr-err'); if (e) e.remove(); }
        }
        saveDraft();
        return;
      }
      if (el.matches('[data-cbind]')) {
        var c = state.data.changes[+el.getAttribute('data-i')];
        if (c) { c[el.getAttribute('data-cbind')] = el.value; saveDraft(); }
        return;
      }
      if (el.matches('[data-dbind]') && state.draft) state.draft[el.getAttribute('data-dbind')] = el.value;
      if (el.matches('[data-lbind]')) {
        var lt = locTarget(el.getAttribute('data-ctx') + ':' + el.getAttribute('data-j'));
        if (lt && lt.loc) {
          lt.loc.placement = el.value;
          delete state.errors[(lt.draft ? 'draftPlace_' : 'place_' + lt.c.id + '_') + lt.j];
          if (!lt.draft) { syncFirst(lt.c); saveDraft(); }
        }
      }
    }
    function onChange(ev) {
      var el = ev.target;
      if (el.matches('[data-mlsu-file]')) { addFiles(el.files, el.getAttribute('data-mlsu-file')); el.value = ''; return; }
      if (el.matches('[data-lbind]')) {
        onInput(ev);
        // The other locations drop this spot from their lists, so repaint.
        var lt2 = locTarget(el.getAttribute('data-ctx') + ':' + el.getAttribute('data-j'));
        if (lt2 && lt2.draft) { grabModal(); renderModal(); } else { grabInputs(); render(); }
        return;
      }
      if (el.matches('[data-cbind], [data-dbind], [data-bind]')) onInput(ev);
    }
    function bindDrops(scope) {
      scope.addEventListener('dragover', function (ev) {
        var z = ev.target.closest('.mlsr-drop');
        if (z) { ev.preventDefault(); z.classList.add('is-drag'); }
      });
      scope.addEventListener('dragleave', function (ev) {
        var z = ev.target.closest('.mlsr-drop');
        if (z) z.classList.remove('is-drag');
      });
      scope.addEventListener('drop', function (ev) {
        var z = ev.target.closest('.mlsr-drop');
        if (!z) return;
        ev.preventDefault();
        z.classList.remove('is-drag');
        var inp = z.querySelector('[data-mlsu-file]');
        if (inp && ev.dataTransfer) addFiles(ev.dataTransfer.files, inp.getAttribute('data-mlsu-file'));
      });
    }

    root.addEventListener('click', onClick);
    root.addEventListener('input', onInput);
    root.addEventListener('change', onChange);
    bindDrops(root);
    root.addEventListener('focusin', function (ev) { if (ev.target.matches('[data-mlsu-storeq]')) loadIndex(); });
    root.addEventListener('keydown', function (ev) {
      if (ev.target.matches('[data-mlsu-storeq]') && ev.key === 'Enter') {
        ev.preventDefault();
        var first = root.querySelector('[data-mlsu-sugg]:not([hidden]) .mlsu-sugg__o');
        if (first) first.click();
      }
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && state.zoom) { closeZoom(); return; }
      if (ev.key === 'Escape' && state.modal && !document.querySelector('[data-mlsr-qvmodal].is-open')) closeModal();
      if (state.zoom && (ev.key === 'ArrowLeft' || ev.key === 'ArrowRight')) {
        var zl2 = zoomList(), zi2 = zl2.indexOf(state.zoom.color);
        if (zi2 > -1 && zl2.length > 1) { state.zoom = { color: zl2[(zi2 + (ev.key === 'ArrowRight' ? 1 : -1) + zl2.length) % zl2.length] }; renderZoom(); }
      }
    });

    function openChat() {
      try {
        if (window.HubSpotConversations && window.HubSpotConversations.widget) { window.HubSpotConversations.widget.open(); return; }
      } catch (e) {}
      window.location.href = 'mailto:' + (cfg.fallback_email || 'hello@merchloop.com') + '?subject=' + encodeURIComponent('Question about updating my store');
    }

    /* -- the ticket ------------------------------------------------------------------------------- */

    function requestType() {
      var types = {};
      state.data.changes.forEach(function (c) { types[c.type] = 1; });
      var k = Object.keys(types);
      return k.length === 1 ? k[0] : 'multi';
    }
    function countsText() {
      var a = changes('add').length, r = changes('artwork').length, s = changes('swap').length, bits = [];
      if (a) bits.push(a + (a === 1 ? ' new product' : ' new products'));
      if (r) bits.push(r + (r === 1 ? ' artwork change' : ' artwork changes'));
      if (s) bits.push(s + (s === 1 ? ' product swap' : ' product swaps'));
      return bits.join(', ');
    }
    function subjectLine() {
      var t = requestType();
      var label = t === 'multi' ? 'Multiple changes' : HS_TYPE[t];
      return 'Store update: ' + (state.data.store ? state.data.store.title : '') + ' (' + label + ', ' + countsText() + ')';
    }
    function artLabel(c, loc) {
      var lid = (loc || ensureLocs(c).locs[0]).logoId;
      if (lid && logoById(lid)) {
        var l = logoById(lid);
        var sent = !(state.noFiles || state.unattached[l.id]);
        return logoName(lid) + (sent ? '' : ' NOT attached, ask the customer to email it');
      }
      return c.type === 'swap' ? 'same artwork as the current product' : 'the store\'s current artwork';
    }
    function catOf(c) { var m = catMatch[String(c.pid)]; return m && m.state === 'ready' ? m : null; }
    function productIdNum(id) { return String(id).replace(/\D/g, ''); }

    function locLines(o, c, fallback) {
      ensureLocs(c).locs.forEach(function (l, j) {
        o.push('     Location ' + (j + 1) + ': ' + (l.placement || fallback) + '  |  Artwork: ' + artLabel(c, l));
      });
    }
    function summaryText() {
      var d = state.data, o = [], origin = window.location.origin;
      var store = d.store || { title: '', handle: '' };
      o.push('STORE UPDATE REQUEST: ' + store.title);
      o.push('Store: ' + store.title + '  (collection handle: ' + store.handle + ')');
      o.push('Store link: ' + origin + '/collections/' + store.handle);
      o.push('Requested by: ' + (d.firstName + ' ' + d.lastName).trim() + ' <' + d.email.trim() + '>, ' + d.phone.trim());
      o.push('Changes: ' + d.changes.length + ' (' + countsText() + ')');
      o.push('');
      if (state.logos.length) {
        o.push('ARTWORK FILES (' + state.logos.length + ')');
        state.logos.forEach(function (l, i) {
          o.push('  Logo ' + (i + 1) + ': ' + l.name + ((state.noFiles || state.unattached[l.id]) ? '  NOT attached, ask the customer to email it' : '  attached'));
        });
      } else {
        o.push('ARTWORK: no new files. Use the artwork already in the store.');
      }

      var adds = changes('add');
      if (adds.length) {
        o.push('');
        o.push('NEW PRODUCTS (' + adds.length + '). Add to the store.');
        adds.forEach(function (c, i) {
          o.push('  ' + (i + 1) + '. ' + c.title + '  [catalog handle: ' + c.h + ']');
          o.push('     ' + origin + (c.url || '/products/' + c.h));
          if (c.colors && c.colors.length) o.push('     Colors: ' + c.colors.join(', '));
          locLines(o, c, 'standard');
          if (c.notes) o.push('     Notes: ' + c.notes);
        });
      }
      var arts = changes('artwork');
      if (arts.length) {
        o.push('');
        o.push('ARTWORK CHANGES (' + arts.length + '). Move the current product to DRAFT, then build a new one with the new artwork.');
        arts.forEach(function (c, i) {
          o.push('  ' + (i + 1) + '. ' + c.title + '  [Shopify product ' + productIdNum(c.pid) + ', handle: ' + c.ph + ']');
          if (catOf(c)) o.push('     Catalog product: ' + catOf(c).title + '  [catalog handle: ' + catOf(c).h + ']');
          locLines(o, c, 'same place as now');
          if (c.notes) o.push('     Notes: ' + c.notes);
        });
      }
      var swaps = changes('swap');
      if (swaps.length) {
        o.push('');
        o.push('PRODUCT SWAPS (' + swaps.length + '). Move the current product to DRAFT, then build the replacement.');
        swaps.forEach(function (c, i) {
          o.push('  ' + (i + 1) + '. Replace: ' + c.title + '  [Shopify product ' + productIdNum(c.pid) + ', handle: ' + c.ph + ']');
          if (c.to) {
            o.push('     With: ' + c.to.title + '  [catalog handle: ' + c.to.h + ']');
            o.push('     ' + origin + (c.to.url || '/products/' + c.to.h));
          }
          if (c.colors && c.colors.length) o.push('     Colors: ' + c.colors.join(', '));
          locLines(o, c, 'standard');
          if (c.notes) o.push('     Notes: ' + c.notes);
        });
      }
      if (d.notes && d.notes.trim()) { o.push(''); o.push('NOTES'); o.push(d.notes.trim()); }

      // Machine readable copy for the agentic build. Same facts as above, so a
      // person can work from the text and the pipeline from this.
      o.push('');
      o.push('--- AGENTIC BUILD PAYLOAD (JSON) ---');
      o.push(JSON.stringify(payload()));
      o.push('--- END PAYLOAD ---');
      return o.join('\n');
    }
    function payload() {
      var d = state.data;
      function logoRef(c) {
        if (!c.logoId || !logoById(c.logoId)) return null;
        var l = logoById(c.logoId);
        return { index: logoIndex(c.logoId) + 1, file: l.name, attached: !(state.noFiles || state.unattached[l.id]) };
      }
      return {
        v: 1,
        kind: 'store_update',
        request_type: HS_TYPE[requestType()],
        store: { title: d.store && d.store.title, collection_handle: d.store && d.store.handle },
        contact: { first_name: d.firstName.trim(), last_name: d.lastName.trim(), email: d.email.trim(), phone: d.phone.trim() },
        changes: d.changes.map(function (c) {
          ensureLocs(c);
          var base = { type: c.type, placement: c.placement || null, artwork: logoRef(c), notes: c.notes || null,
            locations: c.locs.map(function (l) { return { placement: l.placement || null, artwork: logoRef(l) }; }) };
          if (c.type === 'add') {
            base.catalog_handle = c.h; base.title = c.title; base.colors = c.colors || [];
          } else {
            base.current_product = { id: 'gid://shopify/Product/' + productIdNum(c.pid), handle: c.ph, title: c.title, action: 'set_status_draft',
              catalog_handle: catOf(c) ? catOf(c).h : null };
            if (c.type === 'swap' && c.to) { base.replacement = { catalog_handle: c.to.h, title: c.to.title }; base.colors = c.colors || []; }
            if (c.type === 'artwork') base.keep_same_product = true;
          }
          return base;
        }),
        notes: d.notes || null,
        page: window.location.href
      };
    }

    /* -- sending -------------------------------------------------------------------------------------
       Same mechanism as the store request wizard and the request tray: HubSpot's
       embedded form, filled and submitted off screen, because it is the only
       browser path that carries a file. If the embed script is blocked, the Forms
       API still lands the ticket without files, and if that fails too the
       customer gets the whole request as an email they can send. */

    function loadHubSpot() {
      if (window.hbspt && window.hbspt.forms) return Promise.resolve();
      return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = 'https://js.hsforms.net/forms/embed/v2.js';
        s.async = true;
        s.onload = function () { (window.hbspt && window.hbspt.forms) ? resolve() : reject(new Error('hbspt missing')); };
        s.onerror = function () { reject(new Error('hsforms script blocked')); };
        document.head.appendChild(s);
      });
    }

    function baseValues(body) {
      var d = state.data, subject = subjectLine();
      var type = HS_TYPE[requestType()];
      return {
        email: d.email.trim(),
        firstname: d.firstName.trim(),
        lastname: d.lastName.trim(),
        phone: d.phone.trim(),
        company: d.store ? d.store.title : '',
        lead_source_detail: 'Store update request',
        // Picked up the moment a Store Request Type field is on the form. Until
        // then the fill loop skips it, and the subject line carries the type.
        store_request_type: type,
        'TICKET.store_request_type': type,
        message: body,
        'TICKET.subject': subject,
        'TICKET.content': body,
        subject: subject,
        content: body
      };
    }

    function submitHubSpot() {
      if (!cfg.hubspot_portal_id || !cfg.hubspot_form_guid) return Promise.reject(new Error('hubspot not configured'));
      var body = summaryText();
      var values = baseValues(body);
      return loadHubSpot().then(function () {
        return new Promise(function (resolve, reject) {
          var hostId = 'mlsu-hs-' + Date.now();
          var holder = document.createElement('div');
          holder.id = hostId;
          holder.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;overflow:hidden';
          document.body.appendChild(holder);
          var done = false;
          var timer = setTimeout(function () {
            if (!done) { done = true; cleanup(); reject(new Error('HubSpot timed out after 45s')); }
          }, 45000);
          function cleanup() { clearTimeout(timer); setTimeout(function () { holder.remove(); }, 200); }

          window.hbspt.forms.create({
            portalId: cfg.hubspot_portal_id,
            formId: cfg.hubspot_form_guid,
            target: '#' + hostId,
            onFormReady: function (el) {
              var form = el && el.nodeName === 'FORM' ? el : (el && el.querySelector ? el.querySelector('form') : null);
              var scope = form || el || holder;
              function setField(name, value) {
                var input = scope.querySelector('[name="' + name + '"]');
                if (!input) return false;
                if (input.tagName === 'SELECT') {
                  var hit = false;
                  for (var i = 0; i < input.options.length; i++) if (input.options[i].value === String(value)) { hit = true; break; }
                  if (!hit) return false;
                }
                input.value = value;
                input.dispatchEvent(new Event('input', { bubbles: true }));
                input.dispatchEvent(new Event('change', { bubbles: true }));
                return true;
              }
              function fill() { Object.keys(values).forEach(function (n) { setField(n, values[n]); }); }

              state.unattached = {};
              var upl = state.logos.filter(function (l) { return !!l.file; });
              if (upl.length) {
                var fi = scope.querySelector('input[type="file"]');
                var ok = {};
                if (fi && window.DataTransfer) {
                  try {
                    var dt = new DataTransfer();
                    var take = fi.multiple ? upl : upl.slice(0, 1);
                    take.forEach(function (l) { dt.items.add(l.file); ok[l.id] = true; });
                    fi.files = dt.files;
                    fi.dispatchEvent(new Event('change', { bubbles: true }));
                  } catch (e) { ok = {}; }
                }
                upl.forEach(function (l) { if (!ok[l.id]) state.unattached[l.id] = true; });
                if (Object.keys(state.unattached).length) {
                  body = summaryText();
                  values = baseValues(body);
                }
              }
              var tries = 0;
              (function attempt() {
                tries++;
                fill();
                setTimeout(function () {
                  if (done) return;
                  var ta = scope.querySelector('[name="TICKET.content"]');
                  var stuck = ta && String(ta.value || '').length === body.length;
                  if (!stuck && tries < 8) return attempt();
                  var btn = scope.querySelector('input[type="submit"], button[type="submit"]');
                  if (!btn) {
                    if (tries < 8) return attempt();
                    done = true; cleanup();
                    return reject(new Error('HubSpot submit button never rendered'));
                  }
                  btn.click();
                  setTimeout(function () {
                    if (done) return;
                    var again = scope.querySelector('input[type="submit"], button[type="submit"]');
                    if (again) { fill(); again.click(); }
                  }, 2500);
                }, 260);
              })();
            },
            onFormSubmitted: function () {
              if (done) return;
              done = true; cleanup(); resolve({ ok: true, via: 'hubspot' });
            }
          });
        });
      });
    }

    function submitHubSpotApi() {
      if (!cfg.hubspot_portal_id || !cfg.hubspot_form_guid) return Promise.reject(new Error('hubspot not configured'));
      state.noFiles = true;
      var body = summaryText() + '\n\n(Sent via the fallback path: the on page form script was blocked in the visitor\'s browser, so no files are attached.)';
      var v = baseValues(body);
      var fields = ['email', 'firstname', 'lastname', 'phone', 'company', 'TICKET.subject', 'TICKET.content']
        .map(function (n) { return { name: n, value: v[n] }; });
      return fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + cfg.hubspot_portal_id + '/' + cfg.hubspot_form_guid, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fields: fields, context: { pageUri: window.location.href, pageName: document.title } })
      }).then(function (r) { if (!r.ok) throw new Error('hs api ' + r.status); });
    }

    function mailtoHref() {
      var d = state.data;
      var lines = [
        'Our store update request did not submit on the site, so here it is by email.',
        '',
        'Store: ' + (d.store ? d.store.title : ''),
        'Name: ' + d.firstName + ' ' + d.lastName,
        'Email: ' + d.email,
        'Phone: ' + d.phone,
        '',
        'Changes:'
      ].concat(d.changes.map(function (c) {
        if (c.type === 'add') return '- Add ' + c.title;
        if (c.type === 'artwork') return '- New artwork on ' + c.title;
        return '- Swap ' + c.title + (c.to ? ' for ' + c.to.title : '');
      }));
      if (state.logos.length) lines.push('', 'Artwork files to attach: ' + state.logos.map(function (l) { return l.name; }).join(', '));
      return 'mailto:' + (cfg.fallback_email || 'hello@merchloop.com') +
        '?subject=' + encodeURIComponent(subjectLine()) +
        '&body=' + encodeURIComponent(lines.join('\n').slice(0, 1500));
    }

    function submit() {
      if (state.submitting) return;
      grabInputs();
      if (!validateStep(1)) { goTo(1); focusFirstError(); return; }
      if (!validateStep(2)) { goTo(2); return; }
      if (!validateStep(3)) { goTo(3); focusFirstError(); return; }
      state.logos = state.logos.filter(function (l) { return logoInUse(l.id); });
      state.submitting = true;
      state.noFiles = false;
      state.unattached = {};
      state.hsError = '';
      render();
      submitHubSpot()
        .catch(function (e) {
          state.hsError = (e && e.message) || 'unknown';
          if (window.console) console.warn('[mlsu] HubSpot embed failed, trying the API:', state.hsError);
          return submitHubSpotApi();
        })
        .then(function () {
          state.submitting = false;
          try {
            if (window.dataLayer) window.dataLayer.push({
              event: 'store_update_submitted', request_type: HS_TYPE[requestType()],
              changes: state.data.changes.length, store: state.data.store && state.data.store.handle
            });
          } catch (e) {}
          var link = root.querySelector('[data-mlsu-storelink]');
          if (link && state.data.store) {
            link.setAttribute('href', '/collections/' + state.data.store.handle);
            link.textContent = 'Go to my store';
          }
          clearDraft();
          fileClear();
          root.classList.add('is-done');
          root.setAttribute('data-done', 'self');
          scrollTop();
        })
        .catch(function (e) {
          state.submitting = false;
          render();
          var box = root.querySelector('[data-mlsu-submiterr]');
          if (box) {
            var why = [];
            if (state.hsError) why.push('HubSpot: ' + state.hsError);
            if (e && e.message) why.push('fallback: ' + e.message);
            box.innerHTML = 'We could not send your request automatically. Nothing you entered is lost, so you can try again. ' +
              'If it keeps failing, <a href="' + esc(mailtoHref()) + '">email it to us instead</a> and attach your artwork.' +
              (why.length ? '<em class="mlsr-err__why">' + esc(why.join('  |  ')) + '</em>' : '');
            box.classList.add('is-shown');
          }
          if (window.console) console.error('[mlsu] submit failed', { hubspot: state.hsError, fallback: e });
        });
    }

    var again = root.querySelector('[data-mlsu-again]');
    if (again) again.addEventListener('click', function () {
      var keep = { store: state.data.store, firstName: state.data.firstName, lastName: state.data.lastName, email: state.data.email, phone: state.data.phone };
      state.data = { store: keep.store, firstName: keep.firstName, lastName: keep.lastName, email: keep.email, phone: keep.phone, notes: '', changes: [] };
      state.logos = [];
      fileClear();
      root.classList.remove('is-done');
      state.started = true;
      goTo(2);
      notifyPicker();
    });

    /* -- boot ------------------------------------------------------------------------------------------ */

    // Arriving with ?store=<handle> (from a link in the customer's own store, or
    // from an email) skips the search. The handle still has to be in the index.
    var qs = new URLSearchParams(window.location.search);
    var draft = readDraft();
    if (draft) {
      state.data = Object.assign(state.data, draft.data);
      state.started = !!draft.started;
      state.step = Math.min(draft.step || 1, 3);
    }
    state.data.changes.forEach(ensureLocs);
    // No live draft means no file belongs to anything, so clear what is stored.
    if (draft) restoreFiles(); else fileClear();
    var want = (qs.get('store') || '').trim().toLowerCase();
    if (want) {
      state.started = true;
      loadIndex().then(function () {
        var s = STORES.filter(function (x) { return x.h === want; })[0];
        if (s) { pickStore(s); render(); }
      });
    }
    render();
    if (state.data.store) loadStoreProducts();
    root.__mlsu = { state: state, render: render, goTo: goTo };
  }

  function boot() {
    document.querySelectorAll('[data-mlsu-root]').forEach(function (root) {
      if (root.__mlsuBound) return;
      root.__mlsuBound = true;
      try { Wizard(root); } catch (e) {
        if (window.console) console.error('[mlsu] wizard failed to start', e);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
